import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import ReactSimpleImageViewer from "react-simple-image-viewer";
import uuid from "react-uuid";
import toastr from "toastr";
import rightArrow from "../../assets/images/arrow-right.svg";
import phoneImg from "../../assets/images/phoneBot.svg";
import fb from "../../assets/images/fb.svg";
import gift from "../../assets/images/gift.svg";
import help from "../../assets/images/help.svg";
import ins from "../../assets/images/ins.svg";
import leftFeather from "../../assets/images/leftFeather.svg";
import locationpic from "../../assets/images/location.svg";
import overflowImg from "../../assets/images/overflowImg.svg";
import right from "../../assets/images/right.svg";
import rightFeather from "../../assets/images/rightFeather.svg";
import str from "../../assets/images/star.svg";
import tw from "../../assets/images/tw.svg";
import yt from "../../assets/images/yt.svg";
import BookDirectPopup from "../../components/BookDirectPopup/BookDirectPopup";
import Bot9 from "../../components/Bot9/Bot9";
import Checkout from "../../components/Checkout/Checkout";
import Drawer from "../../components/Drawer/Drawer";
import FAQ from "../../components/FAQ/FAQ";
import Footer from "../../components/Footer/Footer";
import HotelAddonComponent from "../../components/HotelAddon/HotelAddonComponent";
import HotelImageComponent from "../../components/HotelImages/HotelImageComponent";
import HotelVideos from "../../components/HotelVideos/hotelVideos";
import IdleBehaviour from "../../components/Idlebehaviour/IdleBehaviour";
import Instaposts from "../../components/Instagram/Instaposts";
import Loader from "../../components/Loader/Loader";
import GoogleMap2 from "../../components/Map/Map";
import NumberAnimator from "../../components/NumberAnimate/NumberAnimator";
import PaymentOption from "../../components/PaymentOptions/PaymentOption";
import Promotion from "../../components/Promotion/Promotion";
import Review from "../../components/Review/Review";
import TripAdvisor from "../../components/Tripadvisor/TripAdvisor";
import WeekView from "../../components/Weekview/Weekview";
import i18 from "../../i18n";
import prevReview from "../../assets/images/prevReview.svg";
import nextReview from "../../assets/images/nextReview.svg";
import {
  available,
  deselectRoom,
  fetchFAQ,
  fetchPayment,
  fetchPaymentProvider,
  fetchPolicy,
  fetchPromotions,
  fetchReview,
  fetchSocialMediaPosts,
  fetchScriptTagId,
  addRoom,
  addRatePlan,
} from "../../redux/actions/hotelInfoAction";
import hotelInfoTypes from "../../redux/actionType/hotelInfoTypes";
import {
  callBotApi,
  cancelBookingWithIdApi,
  cancelInfoApi,
  checkIsLowestApi,
  fetchNearByPlacesApi,
  fetchNearPlacesV2Api,
  findAllKeywordsApi,
  getAboutUsInfoApi,
  viewApi,
  whatsappViewApi,
  gethotelVideosAPI,
  fetchPromotionsApi,
  getBookingForContinueBookingApi,
} from "../../Services/mainPageService";
import storageService from "../../Services/storageService";
import { currency } from "../../utils/currency";
import {
  fireGtmEvent,
  newFBEvents,
  pixelHighIntent,
  pixelPageView,
} from "../../utils/googleAnalytics";
import HotelHelmet from "../../utils/HotelHelmet";
import useOldPriceCalculator from "../../utils/useOldPriceCalculator";
import usePriceCalculator, {
  calculatePromotion,
  getApplicablePromotionRoom,
} from "../../utils/usePriceCalculator";
import useWindowSize from "../../utils/useWindowSize";
import {
  anirudhWhatsappNumber,
  bot9Ids,
  colorHotels,
  couponHotels,
  distanceCalculation,
  excludedProperties,
  EXCLUDE_DISCOUNT_ROOM,
  getCalculatedTax,
  getFixedValue,
  instaProps,
  keywordUTM,
  learAi,
  manualDefaultPlaces,
  removeDuplicateObjectsById,
  removeSpecialCharacters,
  sortRoomsByPriceAndAvailability,
  sourceTest,
  timeSlots,
  deviceType,
  isDev,
  isValidTimeZone,
} from "../../utils/utils";
import "../CheckoutPage/CheckoutPage.css";
import "../LandingPage/LandingPage.css";
import SelectRooms from "../SelectRooms/SelectRooms";
import Dates from "./Dates";
import HotelImageCarousel from "./HotelImageCarousel";
import HourlyDate from "./HourlyDates";
import "./MainPage.css";
import Room from "./Room";
import Bot from "../../components/Bot/Bot";
import Gtag from "../../components/Gtag/Gtag";
import GoogleTagManager from "../../components/Gtag/GoogleTagManager";
import GoogleTagManagerNoScript from "../../components/Gtag/GoogleTagManagerNoScript";
import CancellationPolicy from "../../components/CancellationPolicy/CancellationPolicy";
import PropertyOverview from "../../components/PropertyOverview/PropertyOverview";
import axios from "axios";
import { sortRoomsByPrice } from "../../utils/sort";
import { PiUserCircleFill } from "react-icons/pi";
import MembershipDealsModal from "../../components/Modals/MembershipDealsModal/MembershipDealsModal";
import BeaconCalendar from "./BeaconDates";
import InventoryRetargModal from "../../components/Modals/InventoryRetargetting/InventoryRetargModal";
import { MdNotificationsActive } from "react-icons/md";
import RezylistLoopTxt from "../../components/RezylistLoopTxt/RezylistLoopTxt";
import { getTextKey, shouldUseHotelType } from "../../utils/textConfig";
import close from "../../assets/images/close.svg";

const MainPage = ({ location, host }) => {
  const [enablePopup, setEnablePopup] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: location.match.params.checkin
      ? dayjs(location.match.params.checkin)
      : dayjs(),
    endDate: location.match.params.checkout
      ? dayjs(location.match.params.checkout)
      : dayjs().add(1, "days"),
  });
  const [roomId, setRoomId] = useState("");
  const currentDate = dayjs();
  const [room, setRoom] = useState(1);
  const [adults, setAdults] = useState(1);
  const [child, setChild] = useState(0);
  const [infant, setInfant] = useState(0);
  const [totalPeople, setTotalPeople] = useState(0);
  // const [reviews, setReviews] = useState([]);
  const [nearbyPlaces, setNearbyPlaces] = useState([]);
  const [showMoreDesc, setShowMoreDesc] = useState(false);
  const [checkinTimeMsg, setCheckinTimeMsg] = useState();
  const [isCheckin, setIsCheckin] = useState(false);
  const [houseRules, setHouseRules] = useState();
  const [timeOutId, setTimeOutId] = useState(null);
  const [viewImage, setViewImage] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userId, setUserId] = useState();
  const [showPopup, setShowPop] = useState(false);
  const [menuId, setMenuId] = useState(1);
  const [cancelPhone, setCancelPhone] = useState();
  const [cancelId, setCancelId] = useState();
  const [cancelData, setCancelData] = useState({});
  const [showNoBook, setShowNoBook] = useState(false);
  const [cancelError, setCancelError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [isCOD, setIsCOD] = useState(false);
  const [isBNPL, setIsBNPL] = useState(false);
  const [isOnlyCOD, setIsOnlyCOD] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [lastDate, setLastDate] = useState();
  const [cancellationPolicy, setCancellationPolicy] = useState();
  const [sortedRooms, setSortedRooms] = useState([]);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showModifyPopup, setModifyPopup] = useState(false);
  const [showTimeSlots, setShowTimeSlots] = useState(false);
  const [selectedAm, setSelectedAm] = useState(dayjs().format("A"));
  const [selectedTimeSlot, setSelectedTimeSlot] = useState();
  // checkoit states
  const [totalCost, setTotalCost] = useState();
  const [, setTotalDays] = useState(1);
  const [applyOffer, setApplyOffer] = useState(0);
  const [promotionSelected, setPromotionSelected] = useState();
  const [, setPromotionPrice] = useState();
  const [applicablePromo, setApplicablePromo] = useState();
  const [, setIsOffer] = useState(false);
  const [priceWODiscount, setPriceWODiscount] = useState();
  const [isLowest, setIsLowest] = useState(false);
  const [allAmenities, setAllAmenities] = useState(false);
  const [showMorePlace, setShowMorePlace] = useState(false);
  const [showCancelBtn, setShowCancelBtn] = useState(false);
  const [keywords, setKeywords] = useState("");
  const [showCancellation, setShowCancellation] = useState(false);
  const [extraPrice, setextraPrice] = useState(1);
  const [ownerDetails, setOwnerDetails] = useState({});
  const [eventCount, setEventCount] = useState(0);
  const [showLoyalty, setShowLoyalty] = useState(false);
  const [showFakeConfetti, setShowFakeConfetti] = useState(false);
  const [fakePrice, setFakePrice] = useState(false);
  const [showFakePrice, setShowFakePrice] = useState(false);
  const [languageSelected, setLanguageSelected] = useState("en");
  const [fakeValue, setFakeValue] = useState(1.15);
  const [fakeMultiplier, setFakeMultiplier] = useState(1);
  const [checkInTime, setCheckInTime] = useState("");
  const [checkOutTime, setCheckOutTime] = useState("");
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isDescDrawerOpen, setDescDrawerOpen] = useState(false);
  const [isBotDrawerOpen, setBotDrawerOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(""); // Store phone number
  const [isCalling, setIsCalling] = useState(false); //
  const [isCancelling, setIsCancelling] = useState(false);
  const Location = useLocation();
  const [stayType, setstayType] = useState(null);
  const [showInventoryRetargModal, setShowInventoryRetargModal] =
    useState(false);

  //for sorting reviews
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [valueforSelectedOption, setValueforSelectedOption] = useState(null); //this value will be updated to 5 for most relevant ratings selection and 0 for newsest selection
  const [isLoading, setIsLoading] = useState(true);
  const [showMembershipModal, setShowMembershipModal] = useState({
    isOpen: false,
  });

  const [isLogoutOpen, setLogoutOpen] = useState(false);
  //for sorting based on time stamp
  const [
    AskingForsortedReviewsTimeStampVise,
    setAskingForsortedReviewsTimeStampVise,
  ] = useState(false);

  const [pricingfornotifications, setpricingfornotifications] = useState([]);
  const [promotionRes, setPromotionRes] = useState([{}]);
  const [continueBookingData, setcontinueBookingData] = useState({
    name: "",
    checkIn: "",
    checkOutDate: "",
    NoOfRooms: 0,
    guests: 0,
    bookingIdentity: null,
  });
  const [isDiscardOldBookingOpen, setisDiscardOldBookingOpen] = useState(false);

  //new handlesortchange OR this is only for Newest sorting
  const handleSortChange = (event) => {
    const newValue = event.target.value;
    setValueforSelectedOption((prevValue) => {
      const updatedValue = prevValue === newValue ? null : newValue;
      // Update AskingForsortedReviewsTimeStampVise if "Newest" is selected
      setAskingForsortedReviewsTimeStampVise(updatedValue === "0");
      return updatedValue;
    });
  };
  const dropdownStyle = {
    display: "inline-flex",
    height: "35px",
    padding: "10px",
    alignItems: "center",
    gap: "8px",
    flexShrink: "0",
    position: "absolute",
    top: "45px",
    right: "0",

    borderRadius: "6px",
    border: "1px solid #F8F8F8",
    background: "#FFF",
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.11)",

    minWidth: "150px",
    zIndex: "3000",
  };
  // const [id, setId] = useState(null);

  const handleImage = (id) => {
    setViewImage(true);
    setCurrentIndex(id);
  };

  const dispatch = useDispatch();
  const roomsRef = useRef();
  const reviewRef = useRef();
  const mapRef = useRef();
  const overviewRef = useRef();
  const faqRef = useRef();
  const amenityRef = useRef();
  const hotelAddonRef = useRef();
  const postRef = useRef();
  const { width } = useWindowSize();

  const scrollAddon = (width) => {
    hotelAddonRef.current.scrollLeft += width;
  };

  const scrollReview = (width) => {
    reviewRef.current.scrollLeft += width;
  };

  const {
    fetching,
    hotelData,
    selectedRooms,
    selectedRatePlans,
    selectedAddons,
    totalPeople: totP,
    totalAdult,
    instaLinks,
    totalChild,
    promotions,
    selectedHotelAddons,
    faqs,
    dateCount,
    policies,
    payments,
    isRatePlans,
    reviews,
    reviews_Arjun,
    showHourly,
    hourlyDate,
    isHourlyRoom,
    hourlyTime,
    roomSlots,
    livePricing,
    taxes,
    scriptTagId,
    notifyNoInventory,
    hotel_videos,
    isContinueBooking,
  } = useSelector((state) => state.hotelInfo);
  const wholeState = useSelector((state) => state.hotelInfo);

  // console.log("script", scriptTagId);
  // console.log("checking for prev next buttons", reviews_Arjun);

  useEffect(() => {
    // Trigger loading whenever valueforSelectedOption changes (including reset to null)
    setIsLoading(true); // Show loading sign
    const timeoutId = setTimeout(() => {
      setIsLoading(false); // Hide loading sign after 1 second
    }, 400);

    return () => clearTimeout(timeoutId); // Cleanup timeout
  }, [valueforSelectedOption]);

  //these are the sorted reviews that are being passed to the reviews section

  let sortedReviews = reviews_Arjun?.sort((a, b) => {
    let x = (a?.review_text || "").replace(/[^a-zA-Z]/g, "")?.length; //what if we get null here? in review_text
    let y = (b?.review_text || "").replace(/[^a-zA-Z]/g, "")?.length;

    return y - x; // This will sort in descending order
  });

  sortedReviews = useMemo(() => {
    if (valueforSelectedOption === "5") {
      return reviews_Arjun.filter((review) => review.rating.value === 5);
    }

    if (valueforSelectedOption === "0" && AskingForsortedReviewsTimeStampVise) {
      return [...reviews_Arjun].sort((a, b) => {
        let atimestamp = new Date(a.timestamp);
        let btimestamp = new Date(b.timestamp);
        return btimestamp - atimestamp; // Descending order
      });
    }

    // Default: unsorted reviews
    return reviews_Arjun;
  }, [
    reviews_Arjun,
    valueforSelectedOption,
    AskingForsortedReviewsTimeStampVise,
  ]);

  dayjs.extend(relativeTime);

  //preparing default time stamp for reviews that are older then 1st Jan 2024
  const benchmarkDate = new Date(2024, 0, 1);
  const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
  const benchmarkDateIST = new Date(benchmarkDate.getTime() + istOffset); // Adjust to IST
  const defaultTimeStamp = benchmarkDateIST.toISOString();

  // console.log("data", hotelData);

  const {
    id,
    HotelRooms,
    HotelAddons,
    name,
    HotelImages,
    address,
    longitude,
    latitude,
    state,
    city,
    logo,
    Socials,
    description,
    googlePlaceId,
    websiteSlug,
    whatsappNumber,
    whatsappDial,
    HotelAmenities,
    domain,
  } = hotelData;

  useEffect(() => {
    id && dispatch(fetchScriptTagId(id));
  }, [id]);
  console.log("desc", hotelData?.description);
  const testId = storageService.get("testId") || 0;

  const source = storageService.get("source") || "Google";
  useEffect(() => {
    if (showFakeConfetti) {
      setTimeout(() => {
        setShowFakeConfetti(false);
      }, 5000);
    }
  }, [showFakeConfetti]);

  let isSub = storageService.get("subscribed") || false;
  useEffect(() => {
    let val = storageService.get("extraPrice") || 1;
    if (isHourlyRoom || sourceTest.includes(String(source))) {
      val = 1;
      setShowFakePrice(false);
    } else {
      val = 1.15;
      // setShowFakePrice(true);
    }
    if (isSub) {
      val = 1;
      // setShowFakePrice(true);
    }
    if (
      window.location.href.includes("/rooms/") ||
      sourceTest.includes(String(source))
    ) {
      val = 1;
      setShowFakePrice(false);
    }
    val = 1;
    setShowFakePrice(false);
    setextraPrice(val);
    storageService.set("extraPrice", val);
  }, [source, isHourlyRoom, id, isSub]);

  useEffect(() => {
    let isLoyalty = storageService.get("loyalty") || false;
    if (
      selectedRooms?.length >= 1 &&
      !isLoyalty &&
      !sourceTest.includes(String(source))
    ) {
      // fireGtmEvent("subscribe_popup_shown");
      // setShowLoyalty(true);
      storageService.set("loyalty", true);
    }
  }, [selectedRooms]);

  useEffect(() => {
    const eventCalled = storageService.get("eventCalled") || false;
    if (!eventCalled && eventCount >= 3) {
      storageService.set("eventCalled", true);
      pixelHighIntent("high_intent_user");
    }
  }, [eventCount]);

  useEffect(() => {
    if (policies && policies?.length > 0) {
      let timings = policies?.filter((po) => po?.uiType === "checkin_checkout");
      if (timings?.length > 0) {
        let time = timings[0]?.HotelPolicies[0]?.variables;

        let msg = `Check in: ${time?.checkInTime}  - Check out: ${time?.checkOutTime}`;

        time?.checkInTime?.length > 0
          ? storageService.set("checkin", time?.checkInTime)
          : storageService.set("checkin", "12 PM");
        time?.checkOutTime?.length > 0
          ? storageService.set("checkout", time?.checkOutTime)
          : storageService.set("checkout", "11 AM");
        time?.checkInTime && time?.checkOutTime && setIsCheckin(true);
        setCheckinTimeMsg(msg);
        setCheckInTime(time?.checkInTime || "12 PM");
        setCheckOutTime(time?.checkOutTime || "11 AM");
      }

      let rules = policies?.filter(
        (po) =>
          po?.type === "house_rules" &&
          ["boolean", "custom"].includes(po?.uiType)
      );

      // if (hotelData?.currency === "USD" ) {
      //   const excludeCategories = [
      //     "Unmarried",
      //     "Foreigners",
      //     "Visitors",
      //     "Local",
      //   ];
      //   rules = rules?.filter(
      //     (ru) => !excludeCategories.some((cat) => ru?.category?.includes(cat))
      //   );
      // }
      if (hotelData?.currency === "USD" || hotelData?.id === 26999) {
        const excludeCategories =
          hotelData?.id === 26999
            ? ["Unmarried"]
            : ["Unmarried", "Foreigners", "Visitors", "Local"];
        rules = rules?.filter(
          (ru) => !excludeCategories.some((cat) => ru?.category?.includes(cat))
        );
      }

      setHouseRules(rules);
    }
  }, [policies]);
  // console.log("houserules", houseRules);

  // useEffect(() => {
  //   if (
  //     hotelData?.id &&
  //     hotelData?.minBookingNights > 1 &&
  //     (dayjs(hotelData?.checkOutDate).format("YYYY-MM-DD") !==
  //       dayjs(dateRange?.endDate).format("YYYY-MM-DD") ||
  //       dayjs(hotelData?.checkInDate).format("YYYY-MM-DD") !==
  //         dayjs(dateRange?.startDate).format("YYYY-MM-DD"))
  //   ) {
  //     setDateRange({
  //       startDate: hotelData?.checkInDate,
  //       endDate: hotelData?.checkOutDate,
  //     });
  //   }
  // }, [hotelData]);

  // const sidePanelRef = useRef(null);

  // useEffect(() => {
  //   function updateScrollStyles() {
  //     const sidePanel = sidePanelRef.current;

  //     // Check if the element exists and log the ref status for debugging
  //     if (!sidePanel) {
  //       console.log("sidePanelRef is null, element not found.");
  //       return;
  //     }

  //     // Log the current window height for debugging
  //     console.log("Window innerHeight:", window.innerHeight);

  //     // Check the viewport height
  //     if (window.innerHeight > 800) {
  //       // Adjust the height threshold as needed
  //       console.log("Applying scroll styles!");
  //       sidePanel.style.maxHeight = "80vh"; // Set the maximum height
  //       sidePanel.style.overflowY = "auto"; // Enable scrolling
  //     } else {
  //       sidePanel.style.maxHeight = "none"; // Remove the maximum height
  //       sidePanel.style.overflowY = "visible"; // Disable scrolling
  //     }
  //   }

  //   // Initial check after the component mounts
  //   updateScrollStyles();

  //   // Update on window resize
  //   window.addEventListener("resize", updateScrollStyles);

  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     window.removeEventListener("resize", updateScrollStyles);
  //   };
  // }, []);

  useEffect(() => {
    let source = storageService.get("source");
    if (
      payments?.length > 0 &&
      payments?.some(
        (pay) => pay?.Gateway?.name === "COD" && source !== "g_ads"
      )
    ) {
      setIsCOD(true);
    } else if (payments?.length === 0) {
      setIsCOD(true);
    } else {
      setIsCOD(false);
    }

    if (
      (payments?.length === 1 &&
        payments?.some((pay) => pay?.Gateway?.name === "COD")) ||
      payments?.length === 0
    ) {
      setIsOnlyCOD(true);
    } else {
      setIsOnlyCOD(false);
    }
    if (payments?.some((pay) => pay?.Gateway?.name === "BNPL")) {
      setIsBNPL(true);
    }
  }, [payments]);

  useEffect(() => {
    id && changeThemeColor();
  }, [id]);

  //Trigger Retargetting Modal If No Inventory
  // useEffect(() => {
  //   let timeoutId;
  //   if (notifyNoInventory && dateRange) {
  //     timeoutId = setTimeout(() => {
  //       setShowInventoryRetargModal(true);
  //     }, 5000);
  //   }

  //   return () => {
  //     if (timeoutId) {
  //       clearTimeout(timeoutId);
  //     }
  //   };
  // }, [notifyNoInventory, dateRange]);

  function changeThemeColor() {
    let color = "linear-gradient(95deg,#53b2fe,#065af3)";
    let textClr = "#0078d4";
    let amenityFilter = "";
    let discountClr = "";
    let promotionText = "";
    let bulkBackground = "";
    let bulkBorder = "none";
    let earlyBackground = "";
    let earlyBorder = "none";
    let imageFilter = "";

    if (colorHotels.includes(id)) {
      color = "#FF4E63";
    }
    if (
      hotelData?.id === 29727 ||
      hotelData?.id === 29903 ||
      hotelData?.id === 29947 ||
      hotelData?.id === 29946
    ) {
      color = "#88B341";
    }
    if (hotelData?.userId === 63809) {
      color = "#892680";
    }

    if (hotelData?.userId === 127534) {
      color = "#ffcc09";
    }

    if (hotelData?.chainName === "beacon" || hotelData?.id === 2825) {
      color = "#2a5470";
    }
    if (hotelData?.chainName === "zinc") {
      color = " #D2812B";
    }

    if (hotelData?.userId === 106023 || hotelData?.id === 392) {
      color = "#2B4039";
      textClr = "#2B4039";
      discountClr = "#B55B5A";
      amenityFilter =
        "brightness(0) saturate(100%) invert(17%) sepia(10%) saturate(700%) hue-rotate(120deg) brightness(85%) contrast(95%)";
      bulkBackground = "#2B4039";
      bulkBorder = "#1F2A26";
      earlyBackground = "#B55B5A";
      earlyBorder = "#923F3E";
      promotionText = "white";
      imageFilter = "none";
    }

    document.documentElement.style.setProperty("--blue", color);
    document.documentElement.style.setProperty("--blueText", textClr);

    if (hotelData?.chainName === "beacon" || hotelData?.id === 2825) {
      document.documentElement.style.setProperty(
        "--volte",
        '"Roboto", sans-serif'
      );
      document.documentElement.style.setProperty(
        "--firasans",
        '"Roboto", sans-serif'
      );
    }
    if (hotelData?.chainName === "zinc") {
      document.documentElement.style.setProperty(
        "--volte",
        '"Montserrat", sans-serif'
      );
      document.documentElement.style.setProperty(
        "--firasans",
        '"Roboto", sans-serif'
      );
    }
    // club mahindra
    if (hotelData?.userId === 106023 || hotelData?.id === 392) {
      document.documentElement.style.setProperty(
        "--volte",
        "'Source Sans 3', 'Poppins', 'Inter', sans-serif"
      );
      document.documentElement.style.setProperty(
        "--firasans",
        "'Source Sans 3', 'Poppins', 'Inter', sans-serif"
      );
      document.querySelectorAll(".promotionContent img").forEach((el) => {
        el.style.filter = imageFilter; // Apply the image filter (reset it)
      });
      document.querySelectorAll(".landingPage__Amenity").forEach((el) => {
        el.style.filter = amenityFilter;
      });
      document.querySelectorAll(".promotionText").forEach((el) => {
        el.style.color = promotionText;
      });

      document.querySelectorAll(".recommended").forEach((el) => {
        el.style.color = discountClr;
        el.style.border = `1px solid ${discountClr}`;
      });
      document.querySelectorAll(".discountedPrice").forEach((el) => {
        el.style.color = discountClr;
      });
      console.log("coming here?");
      document.querySelectorAll(".bulk").forEach((el) => {
        el.style.background = bulkBackground;
        el.style.border = `1px solid ${bulkBorder}`;
      });

      document.querySelectorAll(".early").forEach((el) => {
        el.style.background = earlyBackground;
        el.style.border = `1px solid ${earlyBorder}`;
      });
    }

    // vr family

    if (hotelData?.id === 29727 || hotelData?.id === 29903) {
      document.documentElement.style.setProperty(
        "--volte",
        "'Source Serif 4', 'Poppins', 'Inter', sans-serif"
      );
      document.documentElement.style.setProperty(
        "--firasans",
        "'Inter', sans-serif"
      );

      // document.querySelectorAll(".promotionText").forEach((el) => {
      //   el.style.color = promotionText;
      // });

      // document.querySelectorAll(".recommended").forEach((el) => {
      //   el.style.color = discountClr;
      //   el.style.border = `1px solid ${discountClr}`;
      // });
      // document.querySelectorAll(".discountedPrice").forEach((el) => {
      //   el.style.color = discountClr;
      // });

      // document.querySelectorAll(".bulk").forEach((el) => {
      //   el.style.background = bulkBackground;
      //   el.style.border = `1px solid ${bulkBorder}`;
      // });

      // document.querySelectorAll(".early").forEach((el) => {
      //   el.style.background = earlyBackground;
      //   el.style.border = `1px solid ${earlyBorder}`;
      // });
    }
  }

  const a = document.documentElement.style.getPropertyValue("--blue");
  console.log("a: ", a);

  useEffect(() => {
    pixelPageView();
  }, []);

  useEffect(() => {
    if (id) {
      newFBEvents("Search", {
        checkin_date: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
        checkout_date: dayjs(dateRange.endDate).format("YYYY/MM/DD"),
        num_adults: totalAdult,
        num_children: totalChild,
      });
      newFBEvents("ViewContent", {
        content_type: "hotel",
        checkin_date: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
        checkout_date: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
        num_adults: totalAdult,
        num_children: totalChild,
      });
    }
  }, [id]);

  const ln = storageService.get("lang") || "en";

  useEffect(() => {
    Object.keys(hotelData).length === 0 && fetchHotelData();
  }, []);

  useEffect(() => {
    let usr = storageService.get("userId");
    if (usr?.length > 0) {
      setUserId(usr);
    } else {
      let temp = uuid();
      storageService.set("userId", temp);
    }
  }, []);

  useEffect(() => {
    location?.match.params.children && totalChild === 0
      ? setChild(parseInt(location.match.params.children))
      : setChild(totalChild);
    location?.match.params.adult && totalAdult === 2
      ? setAdults(Math.max(parseInt(location.match.params.adult), 1))
      : setAdults(totalAdult);
  }, []);

  useEffect(() => {
    storageService.remove("isBooked");
    const { startDate, endDate } = dateRange;
    if (startDate === null && endDate === null) {
      window.location.reload();
    }
    dispatch({
      type: hotelInfoTypes.SET_DATE,
      payload: {
        startDate: dayjs(startDate),
        endDate: dayjs(endDate),
      },
    });
    dispatch({
      type: hotelInfoTypes.DATE_COUNT,
      payload: dayjs(endDate)?.diff(startDate, "days"),
    });
    // dispatch({
    //   type: hotelInfoTypes.SET_HOURLY_DATE,
    //   payload: new Date(
    //     dayjs(startDate).year(),
    //     dayjs(startDate).month(),
    //     dayjs(startDate).date()
    //   ),
    // });
  }, [dateRange]);

  const campaingId = storageService.get("utmObj") || {};

  useEffect(() => {
    const fetchOwnerDetails = async () => {
      const response = await getAboutUsInfoApi(id);
      setOwnerDetails(response?.data);
    };
    id && fetchOwnerDetails();
  }, [id]);

  // useEffect(() => {
  //   window &&
  //     window.document &&
  //     document.addEventListener(
  //       "DOMSubtreeModified",
  //       function (e) {
  //         if (e.target.tagName === "HTML" && window.google) {
  //           if (e.target.className.match("translated")) {
  //             ga.eventTrack(
  //               "select_content",
  //               "language translated",
  //               hotelData?.name
  //             );
  //           }
  //         }
  //       },
  //       true
  //     );
  // }, []);
  const handleCallBot = async () => {
    fireGtmEvent("call_me_clicked");
    if (!phoneNumber.trim()) {
      alert("Please enter a valid phone number!");
      return;
    }

    const payload = {
      phone_number: phoneNumber, // Phone number entered by user
      task: "Act as front desk manager of Sterling",
      pathway_id: "2f75a6d8-c7b3-4d72-bd9d-bfea61fa4984",
      request_data: {},
      max_duration: 123,
      record: true,
      metadata: {},
      summary_prompt: "<string>",
      analysis_prompt: "<string>",
      analysis_schema: {},
      interruption_threshold: "130",
      wait_for_greeting: false,
      answered_by_enabled: false,
      // country: "in",
      voice: "Giraffe00114455", // Hardcoded value from the provided curl command
    };

    try {
      setIsCalling(true);
      const response = await axios.post(
        "https://api.bland.ai/v1/calls", // API URL from the curl

        payload, // Payload containing phoneNumber, country, and voice
        {
          headers: {
            "Content-Type": "application/json", // Content-Type header
            Authorization:
              "Bearer sk-luj8vgdwd8tl30wlrli0o2ni5ogq62u3higgk0sbkh4u3zlsis2j8mc2lvq4jcwk69",
          },
        }
      );
      if (response.status == 200) {
        toastr.success("call initiated successfully");
        setPhoneNumber("");
        setBotDrawerOpen(false);
      }
    } catch (error) {
      toastr.error("Failed to initiate the call. Please try again.");
    } finally {
      setIsCalling(false);
    }
  };

  const fetchKeywords = async () => {
    let obj = {
      hotelId: id,
    };
    let keys = `${name}, ${name} ${state},stays in ${address}, hotels in ${city}, hotels near ${address}, ${name} ${city}, ${name} ${address}, ${name} book, ${name} cheap stay`;
    const response = await findAllKeywordsApi(obj);
    if (response?.data) {
      const { Callouts = [], Keywords = [] } = response?.data;
      if (Callouts?.length > 0) {
        keys += Callouts?.join(",");
      }
      if (Keywords?.length > 0) {
        keys += Keywords?.join(",");
      }
    }
    setKeywords(keys);
  };

  function calculateRooms(room) {
    const { availableRooms, maxGuestCount } = room;
    let rooms = [];
    let remainingAdults = totalAdult;
    let remainingChildren = totalChild;

    if ((totalChild > 0 && !room?.extraChildPrice) || isHourlyRoom) {
      return [];
    }

    for (let i = 0; i < availableRooms; i++) {
      if (remainingAdults === 0 && remainingChildren === 0) break;

      let currentRoom = {
        adults: 0,
        children: 0,
      };

      // Ensure at least one adult in the room
      if (remainingAdults > 0) {
        currentRoom.adults = 1;
        remainingAdults -= 1;
      } else {
        break; // No more adults to place with children
      }

      // Fill the remaining space in the room with children first
      let remainingSpace = maxGuestCount - currentRoom.adults;
      if (remainingChildren > 0) {
        if (remainingChildren >= remainingSpace) {
          currentRoom.children = remainingSpace;
          remainingChildren -= remainingSpace;
        } else {
          currentRoom.children = remainingChildren;
          remainingChildren = 0;
        }
      }

      // Fill any remaining space with adults
      remainingSpace =
        maxGuestCount - (currentRoom.adults + currentRoom.children);
      if (remainingSpace > 0 && remainingAdults > 0) {
        if (remainingAdults >= remainingSpace) {
          currentRoom.adults += remainingSpace;
          remainingAdults -= remainingSpace;
        } else {
          currentRoom.adults += remainingAdults;
          remainingAdults = 0;
        }
      }

      rooms.push(currentRoom);
    }

    // Check if all guests are accommodated
    if (remainingAdults > 0 || remainingChildren > 0) {
      return [];
    }

    return rooms;
  }

  useEffect(() => {
    if (HotelRooms && HotelRooms?.length > 1 && !isRatePlans) {
      let availRooms = HotelRooms?.filter((rm) =>
        rm?.pricing?.every((rv) => rv?.roomCount > 0)
      );

      let nonAvailRooms = HotelRooms?.filter((rm) =>
        rm?.pricing?.some((rv) => rv?.roomCount === 0)
      );

      let tempArr = [];
      availRooms.forEach((rm) => {
        let tempAdult =
            totalAdult <= rm?.maxGuestCount ? totalAdult : room?.maxGuestCount,
          tempChild = 0,
          tempPrice = 0,
          priceReduced = 0,
          tempTax = 0,
          noDiscPrice = 0,
          promosApplied = [];
        const { pricing = [], priceConfig = {} } = rm;
        const priceForAll = calculateRooms(rm);
        if (priceForAll.length > 0) {
          priceForAll.forEach((pfa) => {
            tempAdult = pfa.adults;
            tempChild = pfa.children;
            pricing.forEach((pr, idx) => {
              let sum = 0,
                prVal = 0;

              sum += pr?.price * parseFloat(priceConfig[tempAdult]);

              // if (tempInfant && tempInfant > 0) {
              //   sum += room?.extraInfantPrice * tempInfant;
              // }

              if (tempChild && tempChild > 0) {
                sum += room?.extraChildPrice * tempChild;
              }
              noDiscPrice += sum;
              const promo = getApplicablePromotionRoom({
                arrangedPromos: promotions,
                rp: { roomId: room?.id },
                tempPrice: sum,
                checkInDate: pr?.date,
              });

              if (promo) {
                promosApplied.push(promo);
              }
              let { finalValue, reducedPrice } = calculatePromotion({
                price: sum,
                promo,
                idx,
                dateCount,
              });

              priceReduced += reducedPrice;

              const taxObj = getCalculatedTax({
                taxes: taxes,
                rooms: [{ id: room?.id, amount: finalValue }],
                isInclusive: hotelData?.isTaxIncluded,
                noOfNights: 1,
              });
              tempPrice +=
                finalValue +
                (hotelData?.isTaxIncluded ? taxObj.totalRoomTax : 0);
              tempTax += Math.abs(taxObj.totalRoomTax);

              // if (hotelData?.userId !== 63809) {
              //   finalValue = finalValue > 8400 ? finalValue / 1.18 : finalValue / 1.12;
              // }
              // tempPrice += finalValue;
              // tempTax += finalValue > 7500 ? finalValue * 0.18 : finalValue * 0.12;

              if (isHourlyRoom) {
                let slotObj = roomSlots[room?.id];
                if (tempAdult <= room?.defaultGuestCount) {
                  tempPrice = noDiscPrice;
                } else {
                  tempPrice = noDiscPrice * priceConfig[room?.sAdult];
                }
                priceReduced = 0;
                tempTax = 0;
              }
            });
          });
        } else {
          pricing.forEach((pr, idx) => {
            let sum = 0,
              prVal = 0;

            sum += pr?.price * parseFloat(priceConfig[tempAdult]);

            // if (tempInfant && tempInfant > 0) {
            //   sum += room?.extraInfantPrice * tempInfant;
            // }

            // if (tempChild && tempChild > 0) {
            //   sum += room?.extraChildPrice * tempChild;
            // }
            noDiscPrice += sum;
            const promo = getApplicablePromotionRoom({
              arrangedPromos: promotions,
              rp: { roomId: room?.id },
              tempPrice: sum,
              checkInDate: pr?.date,
            });

            if (promo) {
              promosApplied.push(promo);
            }
            let { finalValue, reducedPrice } = calculatePromotion({
              price: sum,
              promo,
              idx,
              dateCount,
            });

            priceReduced += reducedPrice;

            const taxObj = getCalculatedTax({
              taxes: taxes,
              rooms: [{ id: room?.id, amount: finalValue }],
              isInclusive: hotelData?.isTaxIncluded,
              noOfNights: 1,
            });
            tempPrice +=
              finalValue + (hotelData?.isTaxIncluded ? taxObj.totalRoomTax : 0);
            tempTax += Math.abs(taxObj.totalRoomTax);

            // if (hotelData?.userId !== 63809) {
            //   finalValue = finalValue > 8400 ? finalValue / 1.18 : finalValue / 1.12;
            // }
            // tempPrice += finalValue;
            // tempTax += finalValue > 7500 ? finalValue * 0.18 : finalValue * 0.12;

            if (isHourlyRoom) {
              let slotObj = roomSlots[room?.id];
              if (tempAdult <= room?.defaultGuestCount) {
                tempPrice = noDiscPrice;
              } else {
                tempPrice = noDiscPrice * priceConfig[tempAdult];
              }
              priceReduced = 0;
              tempTax = 0;
            }
          });
        }

        tempArr.push({ ...rm, searchPrice: tempPrice + tempTax || 0 });
      });

      tempArr.sort((a, b) => a.searchPrice - b.searchPrice);

      setSortedRooms([...tempArr, ...nonAvailRooms]);
    } else if (isRatePlans) {
      // let newRooms = sortRoomsByPriceAndAvailability(HotelRooms);
      let newRooms = sortRoomsByPrice({
        rooms: HotelRooms,
        adultCount: totalAdult,
        childCount: totalChild,
      });

      setSortedRooms(newRooms);
    } else {
      setSortedRooms(HotelRooms);
    }
  }, [HotelRooms, hotelData, isRatePlans]);

  const instaLink = Socials?.filter((soc) => soc.type === "insta");
  const fbLink = Socials?.filter((soc) => soc.type === "fb");
  const twitterLink = Socials?.filter((soc) => soc.type === "twitter");
  const youtubeLink = Socials?.filter((soc) => soc.type === "youtube");

  useEffect(() => {
    setTotalPeople(child + adults + infant);
    dispatch({
      type: hotelInfoTypes.TOTAL_ADULT,
      payload: parseInt(adults),
    });
    dispatch({
      type: hotelInfoTypes.TOTAL_CHILD,
      payload: parseInt(child),
    });
    dispatch({
      type: hotelInfoTypes.TOTAL_INFANT,
      payload: parseInt(infant),
    });
    dispatch({
      type: hotelInfoTypes.TOTAL_PEOPLE,
      payload: parseInt(totalPeople),
    });
  }, [child, adults, totalPeople, infant]);

  const fetchHotelData = async () => {
    var obj;

    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone === "Etc/Unknown") {
      timeZone = null;
    } else {
      timeZone = encodeURIComponent(timeZone);
    }

    // if (location.match.params.id) {
    //   setId(location.match.params.id);
    // }

    let slugDomain = window.location.host.includes(".bookmystay.io")
      ? window.location.host.startsWith("www.")
        ? window.location.host.split(".")[1]
        : window.location.host.split(".")[0]
      : null;

    location.match.params.slug
      ? (obj = {
          websiteSlug: location.match.params.slug,
          checkInDate: dayjs().format("YYYY/MM/DD"),
          checkOutDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
          timezone: timeZone,
        })
      : slugDomain
      ? (obj = {
          websiteSlug: slugDomain,
          checkInDate:
            location.match.params.checkin || dayjs().format("YYYY/MM/DD"),
          checkOutDate:
            location.match.params.checkout ||
            dayjs().add(1, "day").format("YYYY/MM/DD"),
          timezone: timeZone,
        })
      : (obj = {
          id: location.match.params.id,
          checkInDate: location.match.params.checkin,
          checkOutDate: location.match.params.checkout,
          totalAdult: location.match.params.adult,
          totalChildren: location.match.params.children,
          timezone: timeZone,
        });

    location.match.params.slug
      ? storageService.set("source", "Hotelzify")
      : storageService.set("source", "Google");

    if (host?.length > 0 && !slugDomain) {
      let tempDomain = String(host).startsWith("www.")
        ? String(host).slice(4)
        : host;
      obj = {
        domain: tempDomain,
        checkInDate: dayjs().format("YYYY/MM/DD"),
        checkOutDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
        timezone: timeZone,
      };
      storageService.set("source", "Hotelzify");
    }

    window.location.href.includes("bookmystay") &&
      storageService.set("source", "Hotelzify");

    if (window.location.href.includes("/rooms/")) {
      storageService.set("source", "Google");
    }

    storageService.remove("utmObj");
    if (window.location.search.length > 0) {
      let searchArr = window.location.search.split("&");
      let obj;
      searchArr.forEach((srch) => {
        if (srch.startsWith("?")) {
          srch = srch?.replace("?", "");
        }

        let qry = srch.split("=");

        obj = { ...obj, [keywordUTM[qry[0]] || qry[0]]: qry[1] };

        if (qry && qry[0].includes("utm_source")) {
          if (qry[1] === "google_hotel_ads") {
            storageService.set("source", "g_ads");
          } else if (qry[1] === "free_booking_link") {
            storageService.set("source", "Google");
          } else if (qry[1] === "gmb") {
            storageService.set("source", "gmb");
          } else {
            storageService.set("source", qry[1]);
          }
        }
      });
      storageService.set("utmObj", obj);
    }
    let ln = storageService.get("lang") || "en";
    let source = storageService.get("source") || "";
    let referrer = window.document.referrer || "";

    if (source === "Hotelzify" && referrer.includes("google")) {
      storageService.set("source", "SEO");
    }

    if (window.location.href.includes("/render/")) {
      let url = "";
      url = window.location.href.split("url=")[1];
      if (url?.includes("hotelzify.com/")) {
        obj = {
          websiteSlug: url?.split("hotelzify.com/")[1],
          checkInDate: dayjs().format("YYYY/MM/DD"),
          checkOutDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
          timezone: timeZone,
        };
      } else if (url?.includes(".bookmystay.io")) {
        url = url.replace("https://", "");
        obj = {
          websiteSlug: url?.includes(".bookmystay.io")
            ? url?.startsWith("www.")
              ? url?.split(".")[1]
              : url?.split(".")[0]
            : null,
          checkInDate: dayjs().format("YYYY/MM/DD"),
          checkOutDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
          timezone: timeZone,
        };
      } else {
        let temp = url?.split("https://")[1];
        obj = {
          domain: String(temp).startsWith("www.")
            ? String(temp).slice(4)
            : temp,
          checkInDate: dayjs().format("YYYY/MM/DD"),
          checkOutDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
          timezone: timeZone,
        };
      }
    }
    let locat = new URLSearchParams(new URL(window.location.href).search);
    let searchParams = Object.fromEntries(locat);
    // ln = searchParams?.["language"] || "en";
    // storageService.set("lang", ln);
    const roomId = searchParams?.["roomId"] || null;
    if (roomId) {
      setRoomId(roomId);
    }
    if (searchParams?.["date"] === "tomorrow") {
      obj = {
        ...obj,
        checkInDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
        checkOutDate: dayjs().add(2, "days").format("YYYY/MM/DD"),
      };
      setDateRange({
        startDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
        endDate: dayjs().add(2, "day").format("YYYY/MM/DD"),
      });
    } else if (searchParams?.["date"] === "weekend") {
      obj = {
        ...obj,
        checkInDate: dayjs()
          .startOf("week")
          .add(6, "days")
          .format("YYYY/MM/DD"),
        checkOutDate: dayjs()
          .startOf("week")
          .add(7, "days")
          .format("YYYY/MM/DD"),
      };
      setDateRange({
        startDate: dayjs().startOf("week").add(6, "days").format("YYYY/MM/DD"),
        endDate: dayjs().startOf("week").add(7, "days").format("YYYY/MM/DD"),
      });
    } else if (searchParams?.["date"] === "today") {
      obj = {
        ...obj,
        checkInDate: dayjs().format("YYYY/MM/DD"),
        checkOutDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
      };

      setDateRange({
        startDate: dayjs().format("YYYY/MM/DD"),
        endDate: dayjs().add(1, "day").format("YYYY/MM/DD"),
      });
    }

    if (!timeZone) {
      delete obj.timezone;
    }
    dispatch(available(obj, true, ln));
  };

  // useEffect(() => {
  //   if (!roomId || !Array.isArray(hotelData?.HotelRooms)) {
  //     return;
  //   }
  //   const directMatch = hotelData.HotelRooms.find(
  //     (room) => String(room.id) === String(roomId)
  //   );

  //   if (directMatch && !selectedRatePlans?.length && !selectedRooms?.length) {
  //     if (
  //       !directMatch.ratePlans ||
  //       Object.keys(directMatch.ratePlans).length === 0
  //     ) {
  //       const updatedRoom = {
  //         ...directMatch,
  //         sAdult: directMatch.sAdult || directMatch.defaultGuestCount || 2,
  //         sChild: 0,
  //         sInfant: 0,
  //         idx: 1,
  //         roomName: directMatch.roomName || "Unknown Room",
  //       };

  //       dispatch(addRoom(updatedRoom));
  //       return;
  //     }
  //     let ratePlan = null;
  //     if (directMatch.ratePlans) {
  //       const ratePlanKeys = Object.keys(directMatch.ratePlans);
  //       if (ratePlanKeys.length > 0) {
  //         ratePlan = directMatch.ratePlans[ratePlanKeys[0]];
  //       }
  //     }

  //     const x = directMatch?.pricing?.[0]?.ratePlanCode;
  //     const parsedRatePlanConfig = JSON.parse(
  //       directMatch.ratePlans?.[x]?.ratePlanConfig || "{}"
  //     );

  //     const y = parsedRatePlanConfig?.name;
  //     // console.log("rpname", y);

  //     if (ratePlan) {
  //       const payload = {
  //         // sAdult: directMatch.sAdult || directMatch.defaultGuestCount || 2,
  //         sAdult: +(
  //           location?.match?.params?.adult ||
  //           directMatch.defaultGuestCount ||
  //           1
  //         ),
  //         sChild: +(location?.match?.params?.children || 0),
  //         sInfant: 0,
  //         code: ratePlan.code || ratePlan.ratePlanCode,
  //         roomId: directMatch.id,
  //         id: `${directMatch.id}_${x}_0`,
  //         idx: 1,
  //         roomName: directMatch.roomName || "Unknown Room",
  //         RoomImages: directMatch.RoomImages,
  //         rpObject: parsedRatePlanConfig,
  //       };

  //       const obj2 = {
  //         hotelId: hotelData.id,
  //         roomIds: [directMatch.id],
  //         checkInDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
  //         checkOutDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
  //         roomCount: 1,
  //       };

  //       dispatch(addRatePlan(payload, obj2, 0, () => {}));
  //     } else {
  //       return;
  //     }
  //   } else {
  //     return;
  //   }
  // }, [roomId, hotelData]);

  // useEffect(() => {
  //   if (!roomId || !Array.isArray(hotelData?.HotelRooms)) {
  //     return;
  //   }

  //   const directMatch = hotelData.HotelRooms.find(
  //     (room) => String(room.id) === String(roomId)
  //   );

  //   if (directMatch && !selectedRatePlans?.length && !selectedRooms?.length) {
  //     const urlAdults = +(location?.match?.params?.adult || 1);
  //     const urlChildren = +(location?.match?.params?.children || 0);

  //     const calculateRoomsWithParams = (room) => {
  //       const { availableRooms, maxGuestCount } = room;
  //       let rooms = [];
  //       let remainingAdults = urlAdults;
  //       let remainingChildren = urlChildren;

  //       if ((urlChildren > 0 && !room?.extraChildPrice) || isHourlyRoom) {
  //         return [];
  //       }

  //       for (let i = 0; i < availableRooms; i++) {
  //         if (remainingAdults === 0 && remainingChildren === 0) break;

  //         let currentRoom = {
  //           adults: 0,
  //           children: 0,
  //         };
  //         if (remainingAdults > 0) {
  //           currentRoom.adults = 1;
  //           remainingAdults -= 1;
  //         } else {
  //           break;
  //         }

  //         let remainingSpace = maxGuestCount - currentRoom.adults;
  //         if (remainingChildren > 0) {
  //           if (remainingChildren >= remainingSpace) {
  //             currentRoom.children = remainingSpace;
  //             remainingChildren -= remainingSpace;
  //           } else {
  //             currentRoom.children = remainingChildren;
  //             remainingChildren = 0;
  //           }
  //         }

  //         remainingSpace =
  //           maxGuestCount - (currentRoom.adults + currentRoom.children);
  //         if (remainingSpace > 0 && remainingAdults > 0) {
  //           if (remainingAdults >= remainingSpace) {
  //             currentRoom.adults += remainingSpace;
  //             remainingAdults -= remainingSpace;
  //           } else {
  //             currentRoom.adults += remainingAdults;
  //             remainingAdults = 0;
  //           }
  //         }

  //         rooms.push(currentRoom);
  //       }

  //       if (remainingAdults > 0 || remainingChildren > 0) {
  //         return [];
  //       }

  //       return rooms;
  //     };

  //     const roomDistribution = calculateRoomsWithParams(directMatch);

  //     if (roomDistribution.length === 0) {
  //       console.log("Cannot accommodate guests in this room type");
  //       return;
  //     }

  //     if (
  //       !directMatch.ratePlans ||
  //       Object.keys(directMatch.ratePlans).length === 0
  //     ) {
  //       roomDistribution.forEach((roomConfig, index) => {
  //         const updatedRoom = {
  //           ...directMatch,
  //           sAdult: roomConfig.adults,
  //           sChild: roomConfig.children,
  //           sInfant: 0,
  //           idx: index + 1,
  //           roomName: directMatch.roomName || "Unknown Room",
  //         };
  //         dispatch(addRoom(updatedRoom));
  //       });
  //       return;
  //     }
  //     let ratePlan = null;
  //     if (directMatch.ratePlans) {
  //       const ratePlanKeys = Object.keys(directMatch.ratePlans);
  //       if (ratePlanKeys.length > 0) {
  //         ratePlan = directMatch.ratePlans[ratePlanKeys[0]];
  //       }
  //     }

  //     const x = directMatch?.pricing?.[0]?.ratePlanCode;
  //     const parsedRatePlanConfig = JSON.parse(
  //       directMatch.ratePlans?.[x]?.ratePlanConfig || "{}"
  //     );

  //     if (ratePlan) {
  //       roomDistribution.forEach((roomConfig, index) => {
  //         const payload = {
  //           sAdult: roomConfig.adults,
  //           sChild: roomConfig.children,
  //           sInfant: 0,
  //           code: ratePlan.code || ratePlan.ratePlanCode,
  //           roomId: directMatch.id,
  //           id: `${directMatch.id}_${x}_${index}`,
  //           idx: index + 1,
  //           roomName: directMatch.roomName || "Unknown Room",
  //           RoomImages: directMatch.RoomImages,
  //           rpObject: parsedRatePlanConfig,
  //         };

  //         const obj2 = {
  //           hotelId: hotelData.id,
  //           roomIds: [directMatch.id],
  //           checkInDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
  //           checkOutDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
  //           roomCount: 1,
  //         };

  //         dispatch(addRatePlan(payload, obj2, index, () => {}));
  //       });
  //     }
  //   }
  // }, [roomId, hotelData]);

  useEffect(() => {
    if (!roomId || !Array.isArray(hotelData?.HotelRooms)) {
      return;
    }

    const directMatch = hotelData.HotelRooms.find(
      (room) => String(room.id) === String(roomId)
    );

    if (directMatch && !selectedRatePlans?.length && !selectedRooms?.length) {
      const urlAdults = +(location?.match?.params?.adult || 1);
      const urlChildren = +(location?.match?.params?.children || 0);

      const calculateRoomsWithParams = (room) => {
        const { availableRooms, maxGuestCount, maxAdultCount, maxChildCount } =
          room;

        // Get URL parameters
        const requestedAdults = urlAdults;
        const requestedChildren = urlChildren;

        // Get room constraints
        const roomMaxAdults = maxAdultCount || maxGuestCount;
        const roomMaxChildren = maxChildCount || 0;

        console.log("URL Params:", { requestedAdults, requestedChildren });
        console.log("Room Constraints:", {
          roomMaxAdults,
          roomMaxChildren,
          maxGuestCount,
        });

        // Check if room supports children
        if ((requestedChildren > 0 && !room?.extraChildPrice) || isHourlyRoom) {
          return [];
        }

        // Check if we can accommodate within constraints
        if (
          requestedAdults <= roomMaxAdults &&
          requestedChildren <= roomMaxChildren
        ) {
          // Can accommodate exactly as requested
          let rooms = [];
          let remainingAdults = requestedAdults;
          let remainingChildren = requestedChildren;

          for (let i = 0; i < availableRooms; i++) {
            if (remainingAdults === 0 && remainingChildren === 0) break;

            let currentRoom = {
              adults: 0,
              children: 0,
            };

            // Add at least one adult per room
            if (remainingAdults > 0) {
              currentRoom.adults = 1;
              remainingAdults -= 1;
            } else {
              break;
            }

            // Add children
            let remainingSpace = maxGuestCount - currentRoom.adults;
            if (remainingChildren > 0) {
              if (remainingChildren >= remainingSpace) {
                currentRoom.children = remainingSpace;
                remainingChildren -= remainingSpace;
              } else {
                currentRoom.children = remainingChildren;
                remainingChildren = 0;
              }
            }

            // Fill remaining space with adults
            remainingSpace =
              maxGuestCount - (currentRoom.adults + currentRoom.children);
            if (remainingSpace > 0 && remainingAdults > 0) {
              if (remainingAdults >= remainingSpace) {
                currentRoom.adults += remainingSpace;
                remainingAdults -= remainingSpace;
              } else {
                currentRoom.adults += remainingAdults;
                remainingAdults = 0;
              }
            }

            rooms.push(currentRoom);
          }

          // Check if we accommodated everyone
          if (remainingAdults === 0 && remainingChildren === 0) {
            return rooms;
          }
        }

        // Fallback: Use room's maximum constraints
        console.log("Using fallback with room constraints");

        const fallbackAdults = Math.min(roomMaxAdults, requestedAdults);
        const spaceAfterAdults = Math.max(0, maxGuestCount - fallbackAdults);

        // Ensure children are set if there's space and room allows children
        const fallbackChildren =
          requestedChildren > 0 && roomMaxChildren > 0 && spaceAfterAdults > 0
            ? Math.min(roomMaxChildren, requestedChildren, spaceAfterAdults)
            : 0;

        console.log("Fallback calculation:", {
          fallbackAdults,
          spaceAfterAdults,
          roomMaxChildren,
          requestedChildren,
          fallbackChildren,
        });

        return [
          {
            adults: fallbackAdults,
            children: fallbackChildren,
          },
        ];
      };

      const roomDistribution = calculateRoomsWithParams(directMatch);

      if (roomDistribution.length === 0) {
        console.log("Cannot accommodate guests in this room type");
        return;
      }

      if (
        !directMatch.ratePlans ||
        Object.keys(directMatch.ratePlans).length === 0
      ) {
        roomDistribution.forEach((roomConfig, index) => {
          const updatedRoom = {
            ...directMatch,
            sAdult: roomConfig.adults,
            sChild: roomConfig.children,
            sInfant: 0,
            idx: index + 1,
            roomName: directMatch.roomName || "Unknown Room",
          };
          dispatch(addRoom(updatedRoom));
        });
        return;
      }

      let ratePlan = null;
      if (directMatch.ratePlans) {
        const ratePlanKeys = Object.keys(directMatch.ratePlans);
        if (ratePlanKeys.length > 0) {
          ratePlan = directMatch.ratePlans[ratePlanKeys[0]];
        }
      }

      const x = directMatch?.pricing?.[0]?.ratePlanCode;
      const parsedRatePlanConfig = JSON.parse(
        directMatch.ratePlans?.[x]?.ratePlanConfig || "{}"
      );

      if (ratePlan) {
        roomDistribution.forEach((roomConfig, index) => {
          const payload = {
            sAdult: roomConfig.adults,
            sChild: roomConfig.children,
            sInfant: 0,
            code: ratePlan.ratePlanCode,
            roomId: directMatch.id,
            id: `${directMatch.id}_${x}_${index}`,
            idx: index + 1,
            roomName: directMatch.roomName || "Unknown Room",
            RoomImages: directMatch.RoomImages,
            rpObject: { ...parsedRatePlanConfig, id: ratePlan.id },
          };

          const obj2 = {
            hotelId: hotelData.id,
            roomIds: [directMatch.id],
            checkInDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
            checkOutDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
            roomCount: 1,
          };

          dispatch(addRatePlan(payload, obj2, index, () => {}));
        });
      }
    }
  }, [roomId, hotelData]);
  useEffect(() => {
    if (!roomId) return;

    const el = document.getElementById(`room-${roomId}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [sortedRooms, roomId]);

  const fetchOnClick = async () => {
    if (!id) {
      return;
    }
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone === "Etc/Unknown") {
      timeZone = null;
    } else {
      timeZone = encodeURIComponent(timeZone);
    }
    let obj = {
      id,
      checkInDate: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
      checkOutDate: dayjs(dateRange.endDate).format("YYYY/MM/DD"),
      timezone: timeZone,
      isDateChanged: true,
      totalAdult,
      totalChild,
    };
    if (!timeZone) {
      delete obj.timezone;
    }

    if (isHourlyRoom) {
      obj.checkInDate = dayjs(hourlyDate).format("YYYY/MM/DD");
      obj.checkOutDate = dayjs(hourlyDate).add(1, "day").format("YYYY/MM/DD");
    }

    storageService.set("dates", dateRange);

    storageService.set("isPromoShown", false);
    if (isHourlyRoom) {
      let mixObj = {
        ...obj,
        checkInTime: hourlyTime,
        currentDate: dayjs().format("DD/MM/YYYY"),
      };
      fireGtmEvent("hourlySearched", mixObj);
    } else {
      fireGtmEvent("searched", {
        checkInDate: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
        checkOutDate: dayjs(dateRange.endDate).format("YYYY/MM/DD"),
        timezone: timeZone,
        totalAdult,
        totalChild,
        totalPeople,
      });
      if (hotelData?.userId === 103376 && window && window?.gtag) {
        window?.gtag("event", "search", {
          label: hotelData?.name, // The label can be the room type
          value: 1, // Number of rooms selected
          currency: hotelData?.currency,
          items: [
            {
              checkin: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
              checkout: dayjs(dateRange.endDate).format("YYYY/MM/DD"),
              item_id: hotelData?.id, // Room ID or SKU
              item_name: hotelData?.name, // Room name
              quantity: 1,
            },
          ],
        });
      }
      newFBEvents("Search", {
        checkin_date: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
        checkout_date: dayjs(dateRange.endDate).format("YYYY/MM/DD"),
        num_adults: totalAdult,
        num_children: totalChild,
      });
      newFBEvents("ViewContent", {
        content_type: "hotel",
        checkin_date: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
        checkout_date: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
        num_adults: totalAdult,
        num_children: totalChild,
      });
      let isHighCalled = storageService.get("newHighEventCalled") || false;
      if (!isHighCalled) {
        pixelHighIntent("potential_guest");
        storageService.set("newHighEventCalled", true);
      }
    }

    setPromotionSelected(null);

    dispatch(available(obj, false, ln));
    checkIsLowest();
  };

  useEffect(() => {
    if (sortedRooms?.length > 0 && window && id) {
      window?.gtag("event", "page_view", {
        send_to: "AW-11024745253",
        value: sortedRooms[0]?.pricing?.[0]?.price,
        items: [
          {
            id: id,
            start_date: dateRange.startDate,
            end_date: dateRange.endDate,
            google_business_vertical: "hotel_rental",
          },
        ],
      });

      window?.gtag("event", "view_item", {
        value: sortedRooms[0]?.pricing?.[0]?.price,
        items: [
          {
            id: id,
            google_business_vertical: "hotel_rental",
          },
        ],
      });
    }
  }, [sortedRooms, id]);

  // To get scraper data
  // useEffect(() => {
  //   const checkLivePrice = () => {
  //     let obj = {
  //       hotelId: id,
  //       checkInDate: dayjs(dateRange.startDate).format("YYYY/MM/DD"),
  //       checkOutDate: dayjs(dateRange.endDate).format("YYYY/MM/DD"),
  //       checkLive: 1,
  //     };
  //     dispatch(getLivePrice(obj));
  //   };
  //   id && checkLivePrice();
  // }, [id]);

  const checkIsLowest = async () => {
    try {
      const response = await checkIsLowestApi(
        id,
        dayjs(dateRange.startDate).format("YYYY-MM-DD")
      );
      response?.status === 200 && setIsLowest(response?.data);
    } catch (error) {
      fireGtmEvent("error", { name: "checkIsLowest", error });
    }
  };

  useEffect(() => {
    var roomc = 0;
    var roomImgC = 0;

    if (hotelData && HotelRooms) {
      roomc = HotelRooms?.forEach((rm) => {
        roomc += rm?.availableRooms;
        roomImgC += rm?.RoomImages?.length;
      });
    }
    clearTimeout(timeOutId);
    const newTimeOutId = setTimeout(() => {
      userId?.length > 0 &&
        fireGtmEvent("hotel_viewed", {
          hotelImageCount: HotelImages?.length,
          availableRoomsCount: roomc,
          description: description?.length > 0,
          descriptionCount: description?.length,
          amenititesCount: HotelAmenities?.length || 0,
          promotionCount: promotions?.length || 0,
          whatsapp: whatsappNumber?.length > 0 ? true : false,
          hotelAddonCount: HotelAddons?.length || 0,
          nearbyPlaces: nearbyPlaces?.length || 0,
          reviews: reviews?.length || 0,
          rating: reviews?.rating,
          roomImagesCount: roomImgC,
          isRating: reviews?.rating > 0,
          isReview: reviews?.length > 0,
          isHotelImages: HotelImages?.length > 0,
          networkSpeed: window?.navigator?.connection?.effectiveType,
          ghcEnabled: hotelData?.ghcEnabled,
          isGoodProperty:
            reviews?.rating && reviews?.rating >= 4
              ? "Excellent"
              : reviews?.rating === 3
              ? "Good"
              : "Poor/No Review",
          isAvailable: HotelRooms?.some((rm) => rm?.availableRooms > 0),
        });
    }, 1000);
    setTimeOutId(newTimeOutId);
  }, [hotelData, reviews, HotelRooms, promotions, userId]);

  const updateViewsCount = async () => {
    try {
      let viewed = localStorage.getItem("viewed");
      let source = storageService.get("source") || "Hotelzify_Fallback";
      let utmObj = storageService.get("utmObj") || { utmSource: source };
      let testId = 0;
      let showBanner = storageService.get("showBanner") || null;
      let sourceTrack = JSON.parse(localStorage.getItem("visited")) || [];
      let isGHC = storageService.get("isGHC");
      let locat = new URLSearchParams(new URL(window.location.href).search);
      let searchParams = Object.fromEntries(locat);
      let uuids = storageService.get("uuid");
      let locationDetails = storageService.get("locationDetails");
      let HotelRooms = storageService.get("lowestRoom") || {};
      let checkInDate = storageService.get("checkInDate");
      let checkOutDate = storageService.get("checkOutDate");
      searchParams = {
        ...searchParams,
        shownPrice: HotelRooms?.pricing?.[0]?.price,
        promotionSelected,
        discountPrice:
          HotelRooms?.pricing?.[0]?.price - HotelRooms?.pricing?.[0]?.price,
      };

      let rooms = storageService.get("rooms") || [];

      let obj = {
        source,
        deviceType,
        locationDetails,
        testId,
        isGHC,
        isDev: isDev,
        showBanner,
        networkSpeed: window?.navigator?.connection?.effectiveType || "not-set",
        uuid: uuids,
        searchParams,
        checkInDate,
        checkOutDate,
        isAvailable: rooms?.some((rm) => rm?.availableRooms > 0),
        date: dayjs().format("DD-MM-YYYY hh:mm"),
        ...utmObj,
      };
      sourceTrack = [...sourceTrack, { ...obj, hotelId: id }];
      localStorage.setItem("visited", JSON.stringify(sourceTrack));
      const lastViewed = localStorage.getItem("last_viewed");

      if (!lastViewed || dayjs().diff(dayjs(lastViewed), "days") >= 2) {
        obj = { ...obj, sourceTrack };
        await viewApi(id, obj);
        // localStorage.setItem("viewed", true);
        localStorage.setItem("last_viewed", new Date());

        fireGtmEvent("view", obj);
      }
    } catch (error) {
      fireGtmEvent("updateViewCountErorr", { error });
    }
  };

  useEffect(() => {
    id && updateViewsCount();
  }, [id]);

  useEffect(() => {
    const fetchNearPlaces = async () => {
      try {
        const res = await fetchNearPlacesV2Api(id, latitude, longitude);
        if (manualDefaultPlaces[id]) {
          setNearbyPlaces([...manualDefaultPlaces[id], ...res?.data]);
        } else {
          setNearbyPlaces(res?.data);
        }

        if (manualDefaultPlaces[id] && id === 4152) {
          setNearbyPlaces([...manualDefaultPlaces[id]]);
        }
      } catch (error) {}
    };
    nearbyPlaces &&
      latitude !== undefined &&
      longitude !== undefined &&
      id &&
      fetchNearPlaces();
  }, [id, latitude, longitude]);

  useEffect(() => {
    if (id > 0) {
      // console.log("yes we are printing the id", id);
      dispatch(fetchReview(googlePlaceId, id)); // Added closing parenthesis here
    }
  }, [id]);

  useEffect(() => {
    instaLink &&
      instaLink[0]?.link?.length > 2 &&
      dispatch(fetchSocialMediaPosts(instaLink[0]?.link));
  }, [Socials]);

  const sendWhatsappClick = async () => {
    fireGtmEvent("whatsapp_clicked");
    let source = storageService.get("source");
    let utmObj = storageService.get("utmObj") || {};
    let obj = {
      source,
      ...utmObj,
    };
    await whatsappViewApi(id, obj);
  };

  useEffect(() => {
    if (id) {
      const isShowBanner = storageService.get("showBanner") || 0;
      const bannerShowed = storageService.get("bannerShowed") || false;
      const bannerNotShown = storageService.get("bannerNotShown") || false;
      if (isShowBanner === 1 && !bannerShowed) {
        fireGtmEvent("banner_shown");
        storageService.set("bannerShowed", true);
      } else if (isShowBanner === 0 && !bannerNotShown) {
        fireGtmEvent("banner_not_shown");
        storageService.set("bannerNotShown", true);
      }
    }
  }, [id]);

  const handleMenuId = (id) => {
    setMenuId(id);
    id === 1 && overviewRef.current.scrollIntoView();
    id === 2 && roomsRef.current.scrollIntoView();
    id === 3 && mapRef.current.scrollIntoView();
    id === 4 && reviewRef.current.scrollIntoView();
    // id === 5 && cancelBookingRef.current.scrollIntoView();
    id === 6 && amenityRef.current.scrollIntoView();
    id === 7 && faqRef.current.scrollIntoView();
    fireGtmEvent("menu_clicked", {
      menuId: id,
    });
  };

  const handelCancelBooking = async () => {
    if (!cancelPhone) {
      setPhoneError(true);
      setCancelData(null);
      toastr.error("Please enter valid phone number");
      return;
    } else if (!cancelId) {
      toastr.error("Please enter booking id");
      return;
    } else {
      let phoneNumber = parsePhoneNumber(String(cancelPhone));

      let obj = {
        dialCode: `+${phoneNumber?.countryCallingCode}`,
        mobile: phoneNumber?.nationalNumber,
        bookingId: cancelId,
      };

      fireGtmEvent("cancel_booking_verify", {
        cancelData: obj,
      });

      const response = await cancelInfoApi(obj);

      if (response?.status === 200) {
        setCancelData(response?.data);
        if (response?.data?.id) {
          setShowCancelBtn(true);
        }
      } else if (response?.status === 400) {
        setCancelData(null);
        setShowNoBook(true);
        setCancelError(response?.error || response?.message);
      }
      setPhoneError(false);
    }
  };

  useEffect(() => {
    if (policies?.length > 0) {
      let temp =
        policies?.filter((pol) => pol?.type === "cancellation_policy") || [];

      if (temp?.length > 0) {
        temp[0]?.HotelPolicies?.sort(
          (a, b) =>
            b?.variables?.daysBeforeArrival - a?.variables?.daysBeforeArrival
        );

        setCancellationPolicy(temp[0]?.HotelPolicies);
      }
    }
  }, [policies]);

  useEffect(() => {
    let last, diffDays;
    if (cancellationPolicy?.length > 0) {
      last = dayjs(dateRange?.startDate).subtract(
        cancellationPolicy[0]?.variables?.daysBeforeArrival,
        "day"
      );
      if (cancellationPolicy[0]?.variables?.chargedPercentage === 0) {
        last = dayjs(dateRange?.startDate).subtract(
          cancellationPolicy[0]?.variables?.daysBeforeArrival - 1,
          "day"
        );
      }
      diffDays = last?.diff(dayjs(), "day");
      if (diffDays >= 0) {
        setShowCancel(true);
      } else {
        setShowCancel(false);
      }
      setLastDate(last?.format("MMM DD"));
    } else {
      diffDays = dayjs(dateRange?.startDate).diff(dayjs(), "day");

      if (diffDays >= 1) {
        last = dayjs(dateRange?.startDate).subtract(1, "day");
        setShowCancel(true);
        setLastDate(last?.format("MMM DD"));
      }
    }
  }, [cancellationPolicy, dateRange]);

  const removeRoom = (room, count) => {
    // dispatch({ type: hotelInfoTypes.RESET_ROOM, payload: room?.id });
    for (let i = 0; i < count; i++) {
      dispatch(deselectRoom(room));
    }
  };

  // calculate
  useEffect(() => {
    let arr = [...promotions];
    arr.sort((b, a) => a.discount - b.discount);
    setApplicablePromo(arr);
    if (isHourlyRoom) setApplicablePromo([]);
  }, [promotions, isHourlyRoom]);

  useEffect(() => {
    calculateDiscount();
  }, [applyOffer]);

  const calculateDiscount = () => {
    let roomPrice = 0;
    let noDiscPrice = 0;

    if (isHourlyRoom) {
      storageService.remove("discount");
      storageService.remove("promo");
      return;
    }

    selectedRooms.forEach((rm) => {
      const { pricing = [], priceConfigDifference = {} } = rm;
      let val1 =
        totalAdult <= rm?.defaultGuestCount
          ? totalAdult
          : rm?.defaultGuestCount;

      // remove stuff
      if (testId === 0) {
        val1 = rm?.sAdult;
      }
      let prVal = 0;
      // end remove stuff
      if (
        priceConfigDifference &&
        Object.keys(priceConfigDifference).length > 0
      ) {
        pricing.forEach((pr) => {
          const { priceConfig = {} } = pr;
          //   roomPrice +=
          //     parseFloat(pr?.price) + parseFloat(priceConfigDifference[val1]);
          //   prVal += parseFloat(pr?.price);
          if (EXCLUDE_DISCOUNT_ROOM.includes(rm?.id)) {
            noDiscPrice +=
              parseFloat(pr.price) * (parseFloat(priceConfig[val1]) || 1);
          } else if (hotelData?.userId === 63809) {
            let prc = pr?.price;
            prc = prc > 8400 ? prc / 1.18 : prc / 1.12;
            roomPrice += parseFloat(prc) * (parseFloat(priceConfig[val1]) || 1);
          } else {
            roomPrice +=
              parseFloat(pr.price) * (parseFloat(rm?.priceConfig[val1]) || 1);
          }
        });
      } else {
        pricing.forEach((pr) => {
          const { priceConfig = {} } = pr;
          prVal += parseFloat(pr.price);
          if (EXCLUDE_DISCOUNT_ROOM.includes(rm?.id)) {
            noDiscPrice +=
              parseFloat(pr.price) * (parseFloat(priceConfig[val1]) || 1);
          } else if (hotelData?.userId === 63809) {
            let prc = pr?.price;
            prc = prc > 8400 ? prc / 1.18 : prc / 1.12;
            roomPrice += parseFloat(prc) * (parseFloat(priceConfig[val1]) || 1);
          } else {
            roomPrice +=
              parseFloat(pr.price) * (parseFloat(priceConfig[val1]) || 1);
          }
        });
      }

      // remove stuff
      if (testId === 0) {
        if (rm?.sInfant) {
          roomPrice =
            roomPrice + rm?.extraInfantPrice * rm?.sInfant * dateCount;
        }

        if (rm?.sChild) {
          roomPrice = roomPrice + rm?.extraChildPrice * rm?.sChild * dateCount;
        }
      }
      // end remove stuff

      // pricing.forEach((pr) => {
      //   roomPrice =
      //     roomPrice +
      //     parseFloat(pr?.price) * (parseFloat(rm?.priceConfig[val1]) || 1);
      // });
    });

    selectedAddons?.forEach((adn) => {
      if (adn?.Addon?.category === "person") {
        roomPrice =
          roomPrice +
          parseInt(adn?.price) *
            // selectedRooms?.filter((rm) => rm?.id === adn?.hotelRoomId)?.length *
            selectedRooms[0]?.pricing?.length;
      }
    });

    let promoApplied = null;
    let discountAmount = 0;
    let finalAmount = 0;
    let cost = 0;

    if (applicablePromo?.length > 0 && promotions) {
      applicablePromo?.forEach((promo) => {
        if (!promoApplied) {
          if (
            promo?.type === "bulk" &&
            totalCost >= parseFloat(promo?.cutoffAmount)
          ) {
            cost = totalCost;
            discountAmount = (cost * parseFloat(promo?.discount)) / 100;
            finalAmount = cost - discountAmount;
            promoApplied = promo;
            setPromotionSelected(promoApplied);
            !storageService.get("promo") && setIsOffer(true);
            setTimeout(() => setIsOffer(false), 5000);
            // storageService.set("promo", promoApplied);
            setTotalCost(finalAmount);
            setPriceWODiscount(discountAmount);
          } else if (promo?.type === "early" || promo?.type === "late") {
            cost = roomPrice;
            discountAmount = (cost * parseFloat(promo?.discount)) / 100;
            finalAmount = cost - discountAmount;
            promoApplied = promo;
            setPromotionSelected(promoApplied);
            !storageService.get("promo") && setIsOffer(true);
            setTimeout(() => setIsOffer(false), 5000);
            // storageService.set("promo", promoApplied);
            storageService.set("discountedValue", discountAmount);
            if (hotelData?.userId === 63809) {
              setTotalCost(finalAmount);
            } else {
              setTotalCost(parseFloat(totalCost - roomPrice + finalAmount));
            }

            setPriceWODiscount(discountAmount);
          } else {
            storageService.remove("promo");
            setPromotionSelected(null);
            setTotalCost(totalCost);
          }
        }
      });
      setPromotionPrice(parseFloat(finalAmount));
      promoApplied && storageService.set("discount", parseFloat(finalAmount));
    }
  };

  useEffect(() => {
    const calculateCost = () => {
      var prices = 0;

      // var totalPeople = 0;
      // [...new Set(selectedRooms)].map((rm) => {
      //   selectedAddons?.forEach((addon) => {
      //     if (
      //       addon?.Addon?.category === "person" &&
      //       rm?.id === addon?.hotelRoomId
      //     ) {
      //       totalPeople++;
      //     }
      //   });
      // });

      selectedRooms?.forEach((room) => {
        const {
          pricing = [],
          defaultGuestCount,
          priceConfig = {},
          priceConfigDifference = {},
        } = room;
        let totPrice = 0;
        let val =
          totalAdult <= defaultGuestCount ? totalAdult : defaultGuestCount;
        // remove stuff
        if (testId === 0) {
          val = room?.sAdult;
        }
        let prVal = 0;
        // end remove stuff
        if (
          priceConfigDifference &&
          Object.keys(priceConfigDifference).length > 0
        ) {
          pricing.forEach((pr) => {
            let prc = pr?.price;
            if (hotelData?.userId === 63809) {
              prc = prc > 8400 ? prc / 1.18 : prc / 1.12;
            }
            totPrice +=
              parseFloat(prc) + parseFloat(priceConfigDifference[val]) || 1;
            prVal += parseFloat(prc);
          });
        } else {
          pricing.forEach((pr) => {
            let prc = pr?.price;
            if (hotelData?.userId === 63809) {
              prc = prc > 8400 ? prc / 1.18 : prc / 1.12;
            }
            totPrice += parseFloat(prc) * (parseFloat(priceConfig[val]) || 1);
            prVal += parseFloat(prc);
          });
        }

        // remove stuff
        if (testId === 0) {
          if (room?.sInfant) {
            prices =
              prices + room?.extraInfantPrice * room?.sInfant * dateCount;
          }

          if (room?.sChild) {
            prices = prices + room?.extraChildPrice * room?.sChild * dateCount;
          }
        }
        // end remove stuff

        if (isHourlyRoom) {
          let slotObj = roomSlots[room?.id];

          // remove stuff
          if (testId === 0) {
            if (room?.sAdult <= room?.defaultGuestCount) {
              prices += totPrice * slotObj?.percentage;
            } else {
              if (
                priceConfigDifference &&
                Object.keys(priceConfigDifference).length > 0
              ) {
                prices =
                  prices +
                  prVal * slotObj?.percentage +
                  priceConfigDifference[room?.sAdult];
              } else {
                prices =
                  prices +
                  prVal * priceConfig[room?.sAdult] * slotObj?.percentage;
              }
            }
          } else {
            prices += totPrice * slotObj?.percentage;
          }
          // remove stuff end
        } else {
          prices += totPrice;
        }

        setTotalDays(pricing?.length);
      });

      selectedAddons?.forEach((addon) => {
        // const { price = "0" } = addon;
        if (addon?.Addon?.category === "meal") {
          prices =
            prices +
            parseFloat(addon?.price) * selectedRooms[0]?.pricing?.length;
        } else if (addon?.Addon?.category === "person") {
          prices =
            prices +
            parseFloat(addon?.price) * selectedRooms[0]?.pricing?.length;
        }
      });

      selectedHotelAddons?.forEach((adn) => {
        if (adn.Addon.multiplier === "per_day") {
          prices +=
            parseFloat(adn.price) *
            dayjs(dateRange?.endDate)?.diff(dateRange?.startDate, "days");
        } else {
          prices += parseFloat(adn.price);
        }
      });

      if (selectedRooms?.length < 1) {
        storageService.remove("promo");
      }
      setTotalCost(parseFloat(prices));
      setApplyOffer(applyOffer + 1);
      storageService.set("totalPrice", parseFloat(prices));
    };
    calculateCost();
  }, [
    selectedAddons,
    selectedHotelAddons,
    selectedRooms,
    totalAdult,
    roomSlots,
  ]);

  let desktopTaxPrice = 0;

  let isTestSource = sourceTest.includes(source);
  let localExtraValue = 1;
  // isTestSource || isHourlyRoom || window.location.href.includes("/rooms/")
  //   ? 1
  //   : 1.15;

  //this is for the notifications showing on each room and rateplan
  const handleRoomPrice = (roomName, price) => {
    if (roomName && price) {
      setpricingfornotifications((prev) => [...prev, { [roomName]: price }]);
    }
  };

  const handleShowHourly = (show = true) => {
    if (show) {
      if (!isHourlyRoom) {
        fireGtmEvent("hourly_selected");
        fireGtmEvent("hourly");
      } else {
        fireGtmEvent("perNight_selected");
      }
    }

    dispatch({ type: hotelInfoTypes.SET_SLOTS, payload: {} });
    dispatch({ type: hotelInfoTypes.SET_SHOW_HOURLY, payload: !isHourlyRoom });
    dispatch({ type: hotelInfoTypes.RESET, payload: true });
    overviewRef.current.scrollIntoView();
  };

  const handleSelectedTimeSlot = (notAvailable, slot) => {
    if (notAvailable) return;

    setSelectedTimeSlot(slot);
    dispatch({ type: hotelInfoTypes.SET_HOURLY_TIME, payload: slot });
  };

  useEffect(() => {
    if (location?.location?.search?.includes("showHourly") && showHourly) {
      dispatch({ type: hotelInfoTypes.SET_SHOW_HOURLY, payload: true });
    }
  }, [showHourly]);

  const ownerInfoRef = useRef();

  const cancelBookingById = async () => {
    setIsCancelling(true);
    let phoneNumber = parsePhoneNumber(String(cancelPhone));

    let obj = {
      dialCode: `+${phoneNumber?.countryCallingCode}`,
      mobile: phoneNumber?.nationalNumber,
      bookingId: cancelId,
    };

    fireGtmEvent("cancel_booking", {
      cancelData: obj,
    });

    const response = await cancelBookingWithIdApi(obj);
    if (response?.status === 200) {
      toastr.success(t("booking_cancelled_successfully"));
    } else {
      toastr.error(t("try_again_later"));
    }
    setIsCancelling(false);
  };

  const handleModify = () => {
    if (!cancelId) {
      toastr.error("Please enter booking id!");
      return;
    }

    window.location.href = `/bookings/modify/${cancelId}`;
  };

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const attachChatbot = () => {
      const script = document.createElement("script");
      script.src =
        "https://sdk.bot9.ai/bot.js?id=f0160d36-f9e6-4b64-b12b-aa5605307537";

      script.async = true;
      document.body.appendChild(script);
    };

    id === 3213 && attachChatbot();
  }, [id]);

  const customChatWidgetHotels = [
    5157, 5151, 4607, 5160, 4680, 5154, 5171, 5166, 5156, 5153, 5159, 5152,
    4612, 4510, 5173, 5168, 5164, 4611, 4620, 4508, 4619, 5169, 4622, 5163,
    3473, 392,
  ];
  const chainId = hotelData?.chainId;
  // console.log("data", chainId, scriptTagId, hotelData?.id);
  useEffect(() => {
    const script = document.createElement("script");

    script.async = true;
    if (
      // customChatWidgetHotels.includes(id) &&
      !fetching &&
      scriptTagId != null &&
      chainId !== null
      // ![5158].includes(hotelData?.id)
    ) {
      // console.log("here?");
      script.src =
        // "https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.3/js/bootstrap.min.js";
        "https://chatwidget.hotelzify.com/bundle.js";
      script.type = "module";
      document.body.appendChild(script);
      // script.onload = () => {
      //   console.log("Chat widget script loaded successfully");
      // };

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [id, scriptTagId]);

  const oldPriceCalculator = useOldPriceCalculator();

  const changeLanguage = () => {
    let ln = storageService.get("lang") || "en";
    setLanguageSelected(ln);
    i18.changeLanguage(ln);
  };

  useEffect(() => {
    id && changeLanguage();
  }, [id]);

  const priceCalculator = usePriceCalculator();

  // API Changes

  const getPromotions = async () => {
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!isValidTimeZone(timeZone)) {
      timeZone = null;
    } else {
      timeZone = encodeURIComponent(timeZone);
    }
    let url = timeZone
      ? `${id}&checkInDate=${dayjs(dateRange.startDate).format(
          "DD/MM/YYYY"
        )}&checkOutDate=${dayjs(dateRange.endDate).format(
          "DD/MM/YYYY"
        )}&shouldApplyFilter=true&timezone=${timeZone}`
      : `${id}&checkInDate=${dayjs(dateRange.startDate).format(
          "DD/MM/YYYY"
        )}&checkOutDate=${dayjs(dateRange.endDate).format(
          "DD/MM/YYYY"
        )}&shouldApplyFilter=true`;
    dispatch(fetchPromotions(url, id));
  };

  useEffect(() => {
    const fetchApisWithDate = () => {
      Promise.all([getPromotions(), checkIsLowest()]);
    };
    id && fetchApisWithDate();
  }, [id, dateRange.endDate]);

  const getFAQ = async (id) => {
    dispatch(fetchFAQ(id));
  };

  const getPayments = () => {
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone === "Etc/Unknown") {
      timeZone = null;
    } else {
      timeZone = encodeURIComponent(timeZone);
    }
    let obj = {
      hotelId: id,
      timezone: timeZone,
      vendorCampaignId: campaingId["hotel_campaign"],
      currency: hotelData?.currency,
    };
    if (!timeZone) {
      delete obj.timezone;
    }
    dispatch(fetchPayment(obj));
  };

  useEffect(() => {
    const fetchApisWithId = () => {
      if (!id) {
        return;
      }
      Promise.all([
        getFAQ(id),
        dispatch(fetchPolicy(id, ln)),
        dispatch(fetchPaymentProvider(id)),
        getPayments(),
        fetchKeywords(),
      ]);
    };
    id && fetchApisWithId();
  }, [id]);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      const utmPrice = new URLSearchParams(window.location.search).get("price");
      const lowestPrice = parseInt(storageService.get("lowestPrice") ?? "0");
      if (utmPrice && lowestPrice > 0) {
        const priceDiff = Math.abs(parseInt(utmPrice) - lowestPrice.toFixed(2));
        if (priceDiff > 0) {
          fireGtmEvent("price_match_diffrence", {
            utmPrice,
            websitePrice: lowestPrice.toFixed(2),
            difrence: priceDiff,
          });
        }
      }
    }, 5000);

    return () => clearTimeout(timeOut);
  }, []);

  // console.log("Checking learAI for bot", learAi);
  // console.log("Checking hotelData.id bot", hotelData.id);

  const hotelId = storageService.get("hotelId");

  //for demographic based content

  useEffect(() => {
    const params = new URLSearchParams(Location.search);
    const stay = params.get("stay_type");
    if (stay) {
      setstayType(stay.toUpperCase());
    }
  }, [Location.search]);

  const getSecretMemberDealUrl = () => {
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!isValidTimeZone(timeZone)) {
      timeZone = null;
    } else {
      timeZone = encodeURIComponent(timeZone);
    }
    let url = timeZone
      ? `${id}&checkInDate=${dayjs(dateRange.startDate).format(
          "DD/MM/YYYY"
        )}&checkOutDate=${dayjs(dateRange.endDate).format(
          "DD/MM/YYYY"
        )}&shouldApplyFilter=true&timezone=${timeZone}&isMembership=true`
      : `${id}&checkInDate=${dayjs(dateRange.startDate).format(
          "DD/MM/YYYY"
        )}&checkOutDate=${dayjs(dateRange.endDate).format(
          "DD/MM/YYYY"
        )}&shouldApplyFilter=true&isMembership=true`;
    return url;
  };

  const fetchMemberDealPromotion = async () => {
    const url = getSecretMemberDealUrl();
    const response = await fetchPromotionsApi(url);
    setPromotionRes(response);
  };

  useEffect(() => {
    if (id) {
      fetchMemberDealPromotion();
    }
  }, [id]);

  const applyPromotion = () => {
    const url = getSecretMemberDealUrl();
    dispatch(fetchPromotions(url, id));
  };
  const shouldApplyMobileStyle =
    window.innerWidth < 768 &&
    (hotelData?.id === 392 ||
      hotelData?.id === 529 ||
      hotelData?.id === 2825 ||
      hotelData?.chainName === "beacon" ||
      hotelData?.chainName === "zinc");

  useEffect(() => {
    const fetchHotelVideos = async () => {
      try {
        const resVd = await gethotelVideosAPI(hotelData?.id);
        if (
          resVd?.status === 200 &&
          Array.isArray(resVd?.data) &&
          resVd?.data?.length > 0
        ) {
          const hotelVideoObj = resVd?.data?.map((ele) => {
            return {
              cdnURL: ele?.cdnVideoUrl,
              title: ele?.videoStoryName,
              thumbnail: ele?.thumbnailUrl,
            };
          });
          dispatch({
            type: hotelInfoTypes.SET_HOTELVIDEOS,
            payload: hotelVideoObj,
          });
        }
      } catch (error) {
        console.error("Error fetching hotel videos:", error);
      }
    };

    if (hotelData?.id) {
      fetchHotelVideos();
    }
  }, [hotelData?.id]);
  const formatWithLineBreaks = (text) => {
    if (!text) return null;

    // Replace every '\n' with two '\n' characters
    const doubledNewlines = text.replaceAll("\n", "\n\n");

    return doubledNewlines;
  };

  //for continue booking
  useEffect(() => {
    const fetchOldBooking = async (bookingId) => {
      try {
        const res = await getBookingForContinueBookingApi(bookingId);

        if (
          !res?.data ||
          !Array.isArray(res?.data) ||
          res?.data?.length === 0 ||
          !res?.data[0]?.BookingItems?.length ||
          res?.data[0]?.status !== "pending" ||
          res?.data[0]?.hotelId !== id
        )
          return;

        if (res?.status === 200) {
          setcontinueBookingData({
            name: res?.data[0]?.name || "",
            checkIn: res?.data?.[0]?.BookingItems?.[0]?.checkInDate || "",
            checkOutDate: res?.data?.[0]?.BookingItems?.[0]?.checkOutDate || "",
            NoOfRooms: res?.data[0]?.BookingItems?.length || 0,
            guests: res?.data[0]?.totalGuests || 0,
            bookingIdentity: res?.data[0]?.BookingItems[0]?.booking_id || 0,
          });
          dispatch({
            type: hotelInfoTypes.SET_CONTINUE_BOOKING,
            payload: true,
          });
        }
      } catch (error) {
        console.error("Error fetching booking:", error);
      }
    };

    let x = null;
    try {
      x = JSON.parse(localStorage.getItem("bookingId"));
    } catch (err) {
      console.error("Invalid bookingId:", err);
      return;
    }

    if (!x?.bookingId || !x?.date) return;

    const storedDate = new Date(x?.date);

    if (isNaN(storedDate.getTime())) return;

    const today = new Date();
    storedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (storedDate >= today && x?.bookingId) {
      fetchOldBooking(x?.bookingId);
    }
  }, [id]);

  const handleNavigateUserToOldBooking = () => {
    window.open(
      `https://bookmystay.io/checkout/${continueBookingData?.bookingIdentity}`,
      "_blank"
    );
  };

  const contentforContinueBooking = () => {
    const content = (
      <>
        <div
          className="booking-header"
          style={{
            width: "100%",
            marginBottom: "4px",
            marginTop: width < 600 ? "-15px" : "",
          }}
        >
          <p
            className="confirmation-text"
            style={{ marginTop: 0, fontSize: "15px", fontWeight: "500" }}
          >
            We have saved your room,{" "}
            <span
              className="customer-name"
              style={{ color: "#8E44AD", fontWeight: "700" }}
            >
              {continueBookingData?.name}
            </span>
          </p>
        </div>
        <div
          className="booking-details"
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: width > 350 ? "14px" : "13px",
            color: "#666",
            margin: "4px 0 16px 0",
            width: "100%",
          }}
        >
          <span>
            {continueBookingData?.checkIn
              ? dayjs(continueBookingData?.checkIn).format("D MMM 'YY")
              : "N/A"}{" "}
            to{" "}
            {continueBookingData?.checkOutDate
              ? dayjs(continueBookingData?.checkOutDate).format("D MMM 'YY")
              : "N/A"}
          </span>
          <span
            className="dot-separator"
            style={{ margin: "0 8px", fontSize: "14px" }}
          >
            •
          </span>
          <span>{continueBookingData?.NoOfRooms || ""} Rooms</span>
          <span
            className="dot-separator"
            style={{ margin: "0 8px", fontSize: "14px" }}
          >
            •
          </span>
          <span>{continueBookingData?.guests || ""} Guests</span>
        </div>
      </>
    );
    return width > 600 ? (
      <div style={{ display: "flex", flexDirection: "column" }}>{content}</div>
    ) : (
      content
    );
  };

  const handleContinueBookingClose = () => {
    console.log("Reached handleContinueBookingClose");
    setisDiscardOldBookingOpen(true);
  };

  const handleYesDiscardoldBooking = () => {
    dispatch({
      type: hotelInfoTypes.SET_CONTINUE_BOOKING,
      payload: false,
    });

    try {
      localStorage.removeItem("bookingId");
    } catch (err) {
      console.error("BookingId removal", err);
    }
    setisDiscardOldBookingOpen(false);
  };

  return fetching ? (
    <Loader />
  ) : (
    <div className="mainpage ">
      {chainId == 23 ? (
        <div
          style={{
            background: "#0078d4",
            width: "100%",
            color: "white",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "center",
            padding: "5px",
          }}
        >
          <img
            src="https://ik.imagekit.io/hotelzifyprod/phone-call-white-icon_60493e1f-a032-44c4-b344-2141c3b66cfe.png"
            alt="call"
            width={15}
            height={15}
            style={{ marginLeft: "auto" }}
          />
          <span>Call us - 8287264525</span>
          <a
            style={{
              background: "white",
              borderRadius: "5px",
              color: "black",
              padding: "0 10px",
              marginLeft: "auto",
              marginRight: "10px",
            }}
            href="tel:+918287264525"
          >
            Call Now
          </a>
        </div>
      ) : null}
      {/* {hotelData?.id === 320 && <AdSenseWidget />} */}
      {/* {bot9Ids.includes(hotelData?.id) && <Bot9 />} */}
      {/* OLD CODE FOR BOT => {Object.keys(learAi).includes(String(hotelData?.id)) && (
        <Bot learKey={learAi[hotelData?.id]} />
      )} */}
      {scriptTagId &&
      ((!selectedRooms?.length && !selectedRatePlans?.length) ||
        width > 700) ? (
        <div
          id="asc-chatbot"
          data-script-tag-id={scriptTagId}
          hotelzify_chain_id={chainId}
          hotelzify_hotel_id={hotelId}
        ></div>
      ) : // <Bot learKey={scriptTagId} />
      null}
      {/* {scriptTagId &&
      ((!selectedRooms?.length && !selectedRatePlans?.length) ||
        width > 700) ? (
        customChatWidgetHotels.includes(hotelId) ? (
          <>
            <div
              id="asc-chatbot"
              data-script-tag-id={scriptTagId}
              hotelzify_chain_id={chainId}
              hotelzify_hotel_id={hotelId}
            ></div>
          </>
        ) : (
          <Bot learKey={scriptTagId} />
        )
      ) : null} */}
      {hotelData?.userId === 103376 && <Gtag gtagId={"G-1RJM0JN4TW"} />}
      {hotelData?.userId === 103376 && (
        <GoogleTagManager gtmId={"GTM-54GKP27W"} />
      )}
      {hotelData?.userId === 103376 && (
        <GoogleTagManagerNoScript gtmId={"GTM-54GKP27W"} />
      )}
      {/* 29602 */}
      {hotelData?.id === 29602 && <GoogleTagManager gtmId={"GTM-P43MTXP5"} />}
      {hotelData?.id === 29602 && (
        <GoogleTagManagerNoScript gtmId={"GTM-P43MTXP5"} />
      )}
      <HotelHelmet
        title={name}
        HotelImages={HotelImages}
        state={state}
        description={description}
        city={city}
        logo={logo}
        hotelId={hotelData?.id}
        reviews={reviews}
        websiteSlug={websiteSlug}
        HotelRooms={HotelRooms}
        address={address}
        domain={domain}
        currency={hotelData?.currency}
        keywords={keywords}
      />
      {
        <div
          className="giftWrapper"
          onClick={() => {
            setShowPop(true);
            fireGtmEvent("bookDirectOpened");
          }}
        >
          <img src={isLowest ? help : gift} alt="gift" width={30} height={30} />
        </div>
      }
      {width < 901 && (
        <div className="hotelImageCarousel" id="hotelImagePhn">
          <HotelImageCarousel
            hotelImages={HotelImages}
            name={name}
            address={address}
          />
        </div>
      )}
      {HotelImages?.length > 0 && width > 900 && (
        <HotelImageComponent hotelImages={HotelImages} name={name} />
      )}
      <div className="newLanding">
        <div
          className="landingPage__header"
          ref={overviewRef}
          style={{ marginTop: HotelImages?.length === 0 && "40px" }}
        >
          {/* {logo !== "" && logo !== null && logo && (
            <div className="landingPage__logo">
              <img
                src={logo}
                alt={name + " logo image"}
                width={"60"}
                height={"60"}
                onClick={window?.HotelzifySDK?.toggle}
              />
            </div>
          )} */}

          {/* {logo !== "" &&
            logo !== null &&
            logo &&
            hotelData?.id !== 392 &&
            hotelData?.id !== 529 &&
            hotelData?.chainname !== "beacon" && (
              <div className="landingPage__logo">
                <img
                  src={logo}
                  alt={name + " logo image"}
                  width={"60"}
                  height={"60"}
                  onClick={window?.HotelzifySDK?.toggle}
                />
              </div>
            )} */}
          {logo !== "" &&
            logo !== null &&
            logo &&
            (window.innerWidth < 901 ||
              (window.innerWidth >= 1024 &&
                hotelData?.id !== 392 &&
                hotelData?.id !== 529 &&
                hotelData?.chainName !== "beacon" &&
                hotelData?.chainName !== "zinc" &&
                hotelData?.id !== 2825)) && (
              <div
                className={`landingPage__logo ${
                  shouldApplyMobileStyle ? "mobile-padding" : ""
                }`}
              >
                <img
                  src={logo}
                  alt={name + " logo image"}
                  width={"60"}
                  height={"60"}
                  onClick={window?.HotelzifySDK?.toggle}
                />
              </div>
            )}
        </div>

        <div className="sidePanelLogin">
          {" "}
          {promotionRes?.status === 200 &&
            promotionRes?.data?.length > 0 &&
            sessionStorage?.isMembershipUnlocked !== "true" && (
              <div
                style={{
                  border: "none",
                  boxShadow: "none",
                  top: "5px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  // padding: "28px",
                  marginBottom: "10px",
                  justifyContent: "flex-end",
                  zIndex: 3000,
                }}
                className={`sidePanelContainerLogin ${
                  selectedRatePlans?.length || selectedRooms?.length
                    ? "scroll"
                    : ""
                }`}
              >
                {sessionStorage?.isMembershipUnlocked === "true" ? (
                  <>
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        marginBottom: "10px",
                      }}
                      onClick={() => setLogoutOpen(!isLogoutOpen)}
                    >
                      <PiUserCircleFill size={20} />
                      {sessionStorage?.userName && (
                        <p
                          style={{
                            cursor: "pointer",
                            color: "var(--blue)",
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          {sessionStorage?.userName}
                        </p>
                      )}
                    </div>
                    {isLogoutOpen && (
                      <div style={dropdownStyle}>
                        <p
                          style={{
                            cursor: "pointer",
                            color: "var(--blue)",
                            fontSize: "18px",
                            fontWeight: "600",
                            zIndex: "3000",
                          }}
                          onClick={() => {
                            sessionStorage.setItem(
                              "isMembershipUnlocked",
                              "false"
                            );
                            window.location.reload();
                          }}
                        >
                          Logout
                        </p>
                      </div>
                    )}
                  </>
                ) : (
                  <p
                    style={{ cursor: "pointer" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.textDecoration = "underline";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.textDecoration = "none";
                    }}
                    onClick={() => setShowMembershipModal({ isOpen: true })}
                  >
                    <span
                      style={{
                        color: "var(--blue)",
                        fontSize: "18px",
                        fontWeight: "600",
                      }}
                      onClick={() =>
                        dispatch({
                          type: hotelInfoTypes.SET_SIGN_UP,
                          payload: false,
                        })
                      }
                    >
                      Login
                    </span>{" "}
                    or{" "}
                    <span
                      style={{
                        color: "var(--blue)",
                        fontSize: "18px",
                        fontWeight: "600",
                      }}
                      onClick={() =>
                        dispatch({
                          type: hotelInfoTypes.SET_SIGN_UP,
                          payload: true,
                        })
                      }
                    >
                      Sign up
                    </span>
                  </p>
                )}
              </div>
            )}
        </div>
        {width <= 900 && (
          <div className="sidePanel">
            {showMembershipModal?.isOpen && (
              <MembershipDealsModal
                isOpen={showMembershipModal?.isOpen}
                onClose={() => setShowMembershipModal({ isOpen: false })}
                getSecretMemberDealUrl={getSecretMemberDealUrl}
                applyPromotion={applyPromotion}
              />
            )}
          </div>
        )}

        {width > 900 && (
          <div
            className="sidePanel"
            style={{
              height:
                isContinueBooking &&
                selectedRatePlans?.length === 0 &&
                selectedRooms?.length === 0
                  ? "100%"
                  : "98%",
            }}
          >
            {showMembershipModal?.isOpen && (
              <MembershipDealsModal
                isOpen={showMembershipModal?.isOpen}
                onClose={() => setShowMembershipModal({ isOpen: false })}
                getSecretMemberDealUrl={getSecretMemberDealUrl}
                applyPromotion={applyPromotion}
              />
            )}
            <div
              className={`sidePanelContainer ${
                selectedRatePlans?.length || selectedRooms?.length
                  ? "scroll"
                  : ""
              }`}
            >
              <p className="sidePanelHeading">
                <span>{t("booking_summary")}</span>{" "}
                {showHourly &&
                  (!isHourlyRoom ? (
                    <span
                      style={{
                        color: colorHotels.includes(id)
                          ? "#FF4E63"
                          : "var(--blue)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        fireGtmEvent("desktop_right_hourly_clicked");
                        fireGtmEvent("hourly");
                        handleShowHourly(false);
                      }}
                    >
                      {`${t("hourly_booking")} ->`}{" "}
                    </span>
                  ) : (
                    <span
                      style={{ color: "var(--blue)" }}
                      onClick={() => {
                        fireGtmEvent("desktop_right_nightly_clicked");
                        handleShowHourly(false);
                      }}
                    >
                      {`${t("full_night_booking")} ->`}{" "}
                    </span>
                  ))}
              </p>

              {
                isHourlyRoom ? (
                  <HourlyDate
                    location={location}
                    dateRange={dateRange}
                    setEnablePopup={setEnablePopup}
                    setDateRange={setDateRange}
                    setShowTimeSlots={setShowTimeSlots}
                  />
                ) : (
                  // hotelData?.chainName === "zinc" ||
                  // hotelData?.chainName === "beacon" ||
                  // hotelData?.id === 2825 ||
                  // hotelData?.userId === 106023 ?
                  <BeaconCalendar
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "20px !important",
                    }}
                    location={location}
                    dateRange={dateRange}
                    setEnablePopup={setEnablePopup}
                    setDateRange={setDateRange}
                    adults={adults}
                    child={child}
                  />
                )
                // :
                // (
                //   <Dates
                //     style={{
                //       display: "flex",
                //       flexDirection: "column",
                //       padding: "20px !important",
                //     }}
                //     location={location}
                //     dateRange={dateRange}
                //     setEnablePopup={setEnablePopup}
                //     setDateRange={setDateRange}
                //   />
                // )
              }
              {selectedRooms?.length === 0 &&
              priceCalculator.selectedRooms.length === 0 ? (
                <>
                  <button
                    className="sidePanelBtn"
                    onClick={() => handleMenuId(2)}
                  >
                    {shouldUseHotelType(hotelData?.userId) ? (
                      `Select ${hotelData?.HotelType?.name}`
                    ) : !notifyNoInventory ? (
                      t("select_room")
                    ) : (
                      <div
                        className="bellIcon"
                        onClick={() => {
                          setShowInventoryRetargModal(
                            !showInventoryRetargModal
                          );
                          fireGtmEvent("clicked_rezylist_notify_me");
                        }}
                      >
                        Get Notified
                        <MdNotificationsActive size={24} />
                      </div>
                    )}
                  </button>
                  {notifyNoInventory && (
                    <div className="noRoomsRetargettingTxtBox">
                      {/* need looping text */}
                      <RezylistLoopTxt />
                    </div>
                  )}
                </>
              ) : (
                <div className="sidePanelSplit">
                  {!storageService.get("subscribed") &&
                    !sourceTest.includes(source) &&
                    showFakePrice && (
                      <div className="splitBill offerBar">
                        <p className="offerbarTxt">
                          {t("unlock_additional_discount")}
                        </p>
                        <button
                          className="offerBarBtn"
                          onClick={() => {
                            fireGtmEvent("subscribe_popup_shown", {
                              position: "checkout_desktop",
                            });
                            setShowLoyalty(true);
                          }}
                          style={{ fontSize: "0.8rem" }}
                        >
                          {t("unlock")} 🔓
                        </button>
                      </div>
                    )}

                  {removeDuplicateObjectsById(
                    priceCalculator.selectedRooms
                  )?.map((rm, id) => {
                    const {
                      priceConfig = {},
                      priceConfigDifference = {},
                      defaultGuestCount,
                      pricing = [],
                    } = rm?.room;
                    let isDorm = false;
                    if (
                      rm?.HotelRoomAmenities?.some(
                        (amn) =>
                          amn?.Amenity?.name === "Bunk Beds" &&
                          amn?.Amenity?.category === "bed_type"
                      )
                    ) {
                      isDorm = true;
                    }

                    let rmCount = priceCalculator.selectedRooms?.filter(
                      (rmf) => rmf?.id === rm?.id
                    )?.length;
                    let rmDays = dateCount;
                    let guestCountArray = selectedAddons?.filter(
                      (ad) =>
                        ad?.hotelRoomId === rm?.id &&
                        ad?.Addon?.category === "person"
                    );
                    let guestCount = 0;
                    let roomCost = 0;
                    let roomTax = 0;
                    priceCalculator.selectedRooms
                      .filter((rmf) => rmf?.id === rm?.id)
                      .forEach((pmf) => {
                        guestCount += pmf?.sAdult + pmf?.sChild + pmf?.sInfant;
                        roomCost += pmf?.sum + pmf?.priceReduced;
                        // roomTax += pmf?.tax;
                      });

                    storageService.set(
                      "tax",
                      parseFloat(
                        desktopTaxPrice.toFixed(
                          getFixedValue(hotelData?.currency)
                        )
                      )
                    );
                    let oneRoomTax = 0;
                    if (isHourlyRoom) {
                      desktopTaxPrice = 0;
                      oneRoomTax = 0;
                      roomTax = 0;
                    }
                    roomCost += roomTax;

                    // let isSubscribed = storageService.get('subscribed') || false;
                    return (
                      <div className="sidePanelSplitRooms" key={rm?.id}>
                        <div className="sidePanelSplitRoomHeader">
                          <p className="splitRoomName">
                            {rm?.room?.roomName} ({rm?.rpObject?.name})
                          </p>

                          {/* <button onClick={() => removeRoom(rm, rmCount)}>
                            {t("remove")}
                          </button> */}
                        </div>
                        <div className="sidePanelSplitRoomDetails">
                          <div className="sidePanelRoomSplit">
                            <p>
                              {rmCount} {isDorm ? t("bed") : t("room")} x{" "}
                              {`${rmDays} ${t("night")}`} ({guestCount}{" "}
                              {guestCount > 1 ? t("guests") : t("guest")})
                            </p>
                            {
                              <p>
                                {currency(hotelData?.currency)}
                                {(roomCost * localExtraValue).toFixed(
                                  getFixedValue(hotelData?.currency)
                                )}
                              </p>
                            }
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {removeDuplicateObjectsById(
                    oldPriceCalculator.roomObjects
                  )?.map((rm, id) => {
                    let isDorm = false;
                    if (
                      rm?.HotelRoomAmenities?.some(
                        (amn) =>
                          amn?.Amenity?.name === "Bunk Beds" &&
                          amn?.Amenity?.category === "bed_type"
                      )
                    ) {
                      isDorm = true;
                    }

                    let rmCount = oldPriceCalculator.roomObjects?.filter(
                      (rmf) => rmf?.id === rm?.id
                    )?.length;
                    let rmDays = dateCount;
                    let guestCountArray = selectedAddons?.filter(
                      (ad) =>
                        ad?.hotelRoomId === rm?.id &&
                        ad?.Addon?.category === "person"
                    );
                    let guestCount = 0;
                    let roomCost = 0;
                    let roomTax = 0;
                    oldPriceCalculator.roomObjects
                      .filter((rmf) => rmf?.id === rm?.id)
                      .forEach((pmf) => {
                        guestCount += pmf?.sAdult + pmf?.sChild + pmf?.sInfant;
                        roomCost += pmf?.sum + pmf?.priceReduced; //+ pmf?.tax;
                        roomTax += Math.abs(pmf?.tax);
                      });

                    storageService.set(
                      "tax",
                      parseFloat(
                        desktopTaxPrice.toFixed(
                          getFixedValue(hotelData?.currency)
                        )
                      )
                    );
                    // roomCost =
                    //   roomCost +
                    //   (hotelData?.isTaxIncluded
                    //     ? 0
                    //     : oldPriceCalculator.taxObj?.totalRoomTax);
                    if (
                      hotelData?.currency !== "INR" ||
                      isHourlyRoom ||
                      selectedRooms?.some((rm) =>
                        EXCLUDE_DISCOUNT_ROOM.includes(rm?.id)
                      )
                    ) {
                      desktopTaxPrice = 0;
                    }
                    // let isSubscribed = storageService.get('subscribed') || false;
                    return (
                      <div className="sidePanelSplitRooms" key={rm?.id}>
                        <div className="sidePanelSplitRoomHeader">
                          <p className="splitRoomName">{rm?.roomName}</p>

                          {/* <button onClick={() => removeRoom(rm, rmCount)}>
                            {t("remove")}
                          </button> */}
                        </div>
                        <div className="sidePanelSplitRoomDetails">
                          <div className="sidePanelRoomSplit">
                            <p>
                              {rmCount} {isDorm ? t("bed") : t("room")} x{" "}
                              {`${rmDays} ${t("night")}`} ({guestCount}{" "}
                              {guestCount > 1 ? t("guests") : t("guest")})
                            </p>

                            {
                              <p>
                                {currency(hotelData?.currency)}
                                {(roomCost * localExtraValue).toFixed(
                                  getFixedValue(hotelData?.currency)
                                )}
                              </p>
                            }
                          </div>
                          {[...new Set(selectedAddons)]
                            ?.filter(
                              (adn) =>
                                adn?.hotelRoomId === rm?.id &&
                                adn?.Addon?.category !== "person"
                            )
                            ?.map((adn) => {
                              let adnCount = selectedAddons?.filter(
                                (ad) => ad?.id === adn?.id
                              )?.length;
                              return (
                                <div
                                  className="splitAddonDetails"
                                  key={adn?.id}
                                >
                                  <p>
                                    {adnCount} x {adn?.Addon?.name} x {rmDays}{" "}
                                    {t("night")}
                                  </p>
                                  <p
                                    style={{
                                      color:
                                        parseInt(adn?.price) === 0
                                          ? "var(--green)"
                                          : "",
                                    }}
                                  >
                                    {currency(hotelData?.currency)}{" "}
                                    {adn?.price *
                                      rmDays *
                                      adnCount *
                                      localExtraValue}
                                  </p>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
                  {selectedHotelAddons?.length > 0 && (
                    <div className="sidePanelSplitRoomHeader">
                      <p className="splitRoomName">{t("addons")} </p>
                    </div>
                  )}

                  {[...new Set(selectedHotelAddons)]?.map((adn) => {
                    let adnCount = selectedHotelAddons?.filter(
                      (ad) => ad?.id === adn?.id
                    )?.length;
                    return adn.Addon.multiplier === "per_day" ? (
                      <div
                        className="splitAddonDetails"
                        style={{
                          padding: "0 10px",
                          borderBottom: "1px solid #dadada",
                        }}
                        key={adn?.id}
                      >
                        <p>
                          {adn?.name} x {adnCount}
                        </p>
                        <p>
                          {currency(hotelData?.currency)}{" "}
                          {Number(
                            adn?.price * adnCount * dateCount * extraPrice
                          ).toFixed(getFixedValue(hotelData?.currency))}
                        </p>
                      </div>
                    ) : (
                      <div
                        className="splitAddonDetails"
                        style={{
                          padding: "10px",
                          // borderBottom: "1px solid #dadada",
                        }}
                        key={adn?.id}
                      >
                        <p>
                          {adn?.name} x {adnCount}
                        </p>
                        <p>
                          {currency(hotelData?.currency)}{" "}
                          {Number(adn?.price * adnCount * extraPrice).toFixed(
                            getFixedValue(hotelData?.currency)
                          )}
                        </p>
                      </div>
                    );
                  })}

                  {!hotelData?.isTaxIncluded &&
                    priceCalculator.taxObj?.taxes?.map((tx, idx) => {
                      return (
                        tx?.totalTax > 0 &&
                        tx?.level === "booking" && (
                          <div className="splitBill" key={idx}>
                            <p>{tx?.name}</p>
                            <p>
                              +{" "}
                              {currency(hotelData?.currency) ||
                                hotelData?.currency}{" "}
                              {Number(tx?.totalTax * extraPrice).toFixed(
                                getFixedValue(hotelData?.currency)
                              )}
                            </p>
                          </div>
                        )
                      );
                    })}
                  {oldPriceCalculator.taxObj?.taxes?.map((tx, idx) => {
                    return (
                      tx?.totalTax > 0 &&
                      tx?.level === "booking" && (
                        <div className="splitBill" key={idx}>
                          <p>{tx?.name}</p>
                          <p>
                            +{" "}
                            {currency(hotelData?.currency) ||
                              hotelData?.currency}{" "}
                            {Number(tx?.totalTax * extraPrice).toFixed(
                              getFixedValue(hotelData?.currency)
                            )}
                          </p>
                        </div>
                      )
                    );
                  })}

                  {Math.abs(oldPriceCalculator.totalTax) > 0 && (
                    <div className="splitBill">
                      <p>{t("taxes")}</p>
                      <p>
                        + {currency(hotelData?.currency) || hotelData?.currency}{" "}
                        {Number(
                          Math.abs(oldPriceCalculator?.totalTax) * extraPrice
                        ).toFixed(getFixedValue(hotelData?.currency))}
                      </p>
                    </div>
                  )}

                  {!isRatePlans &&
                    oldPriceCalculator.appliedDiscount.discount > 0 &&
                    !isHourlyRoom &&
                    selectedRooms?.some(
                      (rm) => !EXCLUDE_DISCOUNT_ROOM.includes(rm?.id)
                    ) && (
                      <div className="splitBill" style={{ fontWeight: "700" }}>
                        <p style={{ color: "var(--green)" }}>
                          {
                            couponHotels.includes(hotelData?.id)
                              ? t("code_mount_applied")
                              : t("Promotion Applied")
                            // `${promotionNames[promotionSelected?.type]} ${
                            //     promotionSelected?.discount
                            //   }%`
                          }
                        </p>
                        <p style={{ color: "var(--green)" }}>
                          - {currency(hotelData?.currency)}{" "}
                          {(
                            oldPriceCalculator.appliedDiscount.discount *
                            localExtraValue
                          ).toFixed(getFixedValue(hotelData?.currency))}
                        </p>
                      </div>
                    )}

                  {isRatePlans &&
                    priceCalculator.appliedDiscount.discount > 0 && (
                      <div className="splitBill" style={{ fontWeight: "700" }}>
                        <p style={{ color: "var(--green)" }}>
                          {
                            couponHotels.includes(hotelData?.id)
                              ? t("code_mount_applied")
                              : t("Promotion Applied")
                            // `${promotionNames[promotionSelected?.type]} ${
                            //     promotionSelected?.discount
                            //   }%`
                          }
                        </p>
                        <p style={{ color: "var(--green)" }}>
                          - {currency(hotelData?.currency)}{" "}
                          {(
                            priceCalculator.appliedDiscount?.discount *
                            localExtraValue
                          ).toFixed(getFixedValue(hotelData?.currency))}
                        </p>
                      </div>
                    )}

                  {isSub && showFakePrice && (
                    <div className="splitBill" style={{ fontWeight: "700" }}>
                      <p style={{ color: "var(--green)" }}>
                        {t("additional_15_off")}
                      </p>
                      {isRatePlans ? (
                        <p style={{ color: "var(--green)" }}>
                          - {currency(hotelData?.currency)}{" "}
                          {(
                            priceCalculator.rpPrice * localExtraValue -
                            priceCalculator.rpPrice
                          ).toFixed(getFixedValue(hotelData?.currency))}
                        </p>
                      ) : (
                        <p style={{ color: "var(--green)" }}>
                          - {currency(hotelData?.currency)}{" "}
                          {(
                            (oldPriceCalculator.totalPrice +
                              oldPriceCalculator.totalTax) *
                              localExtraValue -
                            (oldPriceCalculator.totalPrice +
                              oldPriceCalculator.totalTax)
                          ).toFixed(getFixedValue(hotelData?.currency))}
                        </p>
                      )}
                    </div>
                  )}

                  <div className="splitBill" style={{ fontWeight: "700" }}>
                    <p style={{ display: "flex", flexDirection: "column" }}>
                      {t("final_price")}{" "}
                      <span
                        style={{ fontSize: "0.8rem", fontWeight: "400" }}
                      ></span>{" "}
                    </p>
                    <p
                      style={{
                        // color: "var(--green)",
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "right",
                      }}
                    >
                      {currency(hotelData?.currency)}{" "}
                      {isRatePlans
                        ? (priceCalculator.appliedDiscount.discount > 0
                            ? (priceCalculator.priceAfterDiscount +
                                priceCalculator.totalAddonCost +
                                // ([2740, 26212, 392].includes(id)
                                //   ? priceCalculator.totalAddonCost
                                //   : 0)
                                priceCalculator.taxObj.totalBookingTax) *
                              extraPrice
                            : (priceCalculator.rpPrice +
                                priceCalculator.taxObj.totalBookingTax) *
                              extraPrice
                          ).toFixed(getFixedValue(hotelData?.currency))
                        : (
                            (oldPriceCalculator.totalPrice +
                              Math.abs(
                                oldPriceCalculator.totalTax +
                                  oldPriceCalculator.taxObj?.totalBookingTax
                              )) *
                            extraPrice
                          ).toFixed(getFixedValue(hotelData?.currency))}
                      {isRatePlans && priceCalculator.rpTax > 0 ? (
                        <span
                          style={{
                            fontSize: "0.8rem",
                            fontWeight: "400",
                            color: "#504D56",
                          }}
                        >
                          + {currency(hotelData?.currency)}{" "}
                          {Number(priceCalculator.rpTax).toFixed(
                            getFixedValue(hotelData?.currency)
                          )}{" "}
                          {t("taxes")}
                        </span>
                      ) : (
                        <span
                          style={{
                            fontSize: "0.8rem",
                            fontWeight: "400",
                            color: "#504D56",
                          }}
                        >
                          ({t("incl_of_taxes")})
                        </span>
                      )}
                    </p>
                  </div>
                  <div
                    className="splitProceed"
                    style={{
                      background: "white",

                      padding: "10px 0 20px 0",
                    }}
                  >
                    <Link
                      to={"/room/checkout"}
                      className="splitProceed"
                      style={{ gap: "10px" }}
                      onClick={() => {
                        const utmObj = storageService.get("utmObj");
                        if (utmObj?.googleSource === "verification") {
                          localStorage.setItem(
                            "bookingState",
                            JSON.stringify(wholeState)
                          );
                        }
                      }}
                    >
                      {t("book_now")}{" "}
                      {isHourlyRoom && (
                        <img
                          src="https://ik.imagekit.io/hotelzifyprod/f4ce4893-c0f4-4475-866b-c5dc54c7c760.svg"
                          width={20}
                          height={20}
                          alt=""
                        />
                      )}
                    </Link>
                  </div>
                </div>
              )}
            </div>

            {isContinueBooking &&
              selectedRooms?.length === 0 &&
              selectedRatePlans?.length === 0 &&
              continueBookingData?.bookingIdentity && (
                <div
                  className="continueYourBooking"
                  style={{
                    top: notifyNoInventory ? "380px" : "330px",
                  }}
                >
                  <img
                    src={close}
                    onClick={handleContinueBookingClose}
                    style={{
                      marginLeft: "400px",
                      marginTop: "-10px",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    className="booking-header"
                    style={{ marginTop: "-15px" }}
                  >
                    <p className="confirmation-text">
                      We have saved your room,{" "}
                      <span className="customer-name">
                        {continueBookingData?.name}
                      </span>
                    </p>
                  </div>
                  <div
                    className="booking-details"
                    style={{ marginTop: "-15px" }}
                  >
                    <span>
                      {" "}
                      {continueBookingData?.checkIn
                        ? dayjs(continueBookingData?.checkIn).format(
                            "D MMM 'YY"
                          )
                        : "N/A"}{" "}
                      to{" "}
                      {continueBookingData?.checkOutDate
                        ? dayjs(continueBookingData?.checkOutDate).format(
                            "D MMM 'YY"
                          )
                        : "N/A"}
                    </span>
                    <span className="dot-separator">•</span>
                    <span>{continueBookingData?.NoOfRooms || ""} Rooms</span>
                    <span className="dot-separator">•</span>
                    <span>{continueBookingData?.guests || ""} Guests</span>
                  </div>
                  <div className="divider"></div>
                  <button
                    onClick={handleNavigateUserToOldBooking}
                    className="continue-button"
                  >
                    Continue Booking
                  </button>{" "}
                </div>
              )}
          </div>
        )}
        <div
          className="headerMain"
          // style={{ marginTop: logo?.length > 0 ? "50px" : "" }}
          style={{
            marginTop:
              logo?.length > 0
                ? window.innerWidth > 768
                  ? "50px"
                  : hotelData?.chainName === "zinc" ||
                    hotelData?.chainName === "beacon" ||
                    hotelData?.id === 2825
                  ? "0"
                  : "50px"
                : "",
          }}
        >
          <div className="landingPage__title">
            <h1>{name}</h1>
          </div>

          <div className="landingPage__address">
            <span style={{ width: "100%" }}>
              <img
                src={locationpic}
                alt="location"
                width={"15px"}
                height="100%"
              />
              <span onClick={() => mapRef?.current?.scrollIntoView()}>
                {address}
              </span>
            </span>
          </div>

          {reviews?.rating > 0 && (
            <div className="landingPage__review">
              <p onClick={() => reviewRef?.current?.scrollIntoView()}>
                <span>
                  <img src={str} alt="rating" height="100%" width={"10px"} />
                </span>{" "}
                <span> {reviews?.rating} </span> |{" "}
                <span>{reviews?.user_ratings_total}</span>
                <span>{t("reviews")}</span>
              </p>
            </div>
          )}
          {[952, 63809, 127464].includes(hotelData?.userId) && <TripAdvisor />}
        </div>

        {hotel_videos?.length > 0 && <HotelVideos />}

        {ownerDetails?.imageUrl?.length > 0 && (
          <div
            className="ownerIntro"
            onClick={() => {
              ownerInfoRef.current.scrollIntoView();
              fireGtmEvent("ownerInfo_clicked");
            }}
          >
            <div className="ownerIntroName">
              <span>{t("hello_there")}</span>
              <p>
                <span>
                  {" "}
                  {t("im")} <b>{ownerDetails?.name}</b>, {t("your_host")} 🙌
                </span>
              </p>
            </div>

            <img
              src={ownerDetails?.cdnImageUrl}
              alt={`${name} owner`}
              width={"70"}
              height={"70"}
              style={{
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #dadada",
              }}
            />
          </div>
        )}

        {/* {instaProps[hotelData?.id] && (
          <div className="instaStories">
            <div className="whatmore-base">
              <div id="whatmoreShopId" data={instaProps[hotelData?.id]}></div>
              <div id="whatmorePrimaryColor" data="#d97676"></div>
              <div id="whatmoreSecondaryColor" data="#d97676"></div>
              <div id="whatmoreStoriesTopBottomPadding" data="0"></div>
              <div id="whatmoreStoryTileSize" data="40"></div>
              <div
                id="whatmorePrimaryFont"
                data="whatmorePrimaryFontFamily"
              ></div>
              <div
                className="whatmore-template-type"
                data="template-stories-a"
              ></div>
              <div id="whatmoreIsInDesignMode" data="false"></div>
              <div className="whatmore-render-root"> </div>
            </div>
          </div>
        )} */}

        {width <= 900 && ownerDetails?.imageUrl && (
          <div className="landingPage__roomTitle">
            <span>{t("travel_dates_and_guests")}</span>
          </div>
        )}

        {/* {width <= 900 && !scrollProperties.includes(id) && (
          <div className="datePeople">
            {isHourlyRoom ? (
              <HourlyDate
                location={location}
                dateRange={dateRange}
                setEnablePopup={setEnablePopup}
                setDateRange={setDateRange}
                setShowTimeSlots={setShowTimeSlots}
              />
            ) : (
              <Dates
                location={location}
                dateRange={dateRange}
                setEnablePopup={setEnablePopup}
                setDateRange={setDateRange}
              />
            )}
          </div>
        )} */}

        {/* Navigation menu */}

        <nav className="mainPageNav">
          <div className="mainPageNavContainer">
            <span
              onClick={() => handleMenuId(1)}
              className={menuId === 1 ? "selectedTab" : ""}
            >
              {t("overview")}
            </span>

            {HotelAmenities?.length > 0 && (
              <span
                className={menuId === 6 ? "selectedTab" : ""}
                onClick={() => handleMenuId(6)}
              >
                {t("amenities")}
              </span>
            )}

            <span
              className={menuId === 2 ? "selectedTab" : ""}
              onClick={() => handleMenuId(2)}
            >
              {t("rooms")}
            </span>

            <span
              className={menuId === 3 ? "selectedTab" : ""}
              onClick={() => handleMenuId(3)}
            >
              {t("map")}
            </span>

            {reviews?.rating > 0 &&
              reviews?.reviews?.some((rv) => rv?.rating > 2) && (
                <span
                  className={menuId === 4 ? "selectedTab" : ""}
                  onClick={() => handleMenuId(4)}
                >
                  {t("reviews")}
                </span>
              )}
            {faqs?.length > 0 && (
              <span
                className={menuId === 7 ? "selectedTab" : ""}
                onClick={() => handleMenuId(7)}
              >
                {t("faqs")}
              </span>
            )}
          </div>
          {width <= 900 && (
            <div className="mainPageNavDate">
              {
                isHourlyRoom ? (
                  <HourlyDate
                    location={location}
                    dateRange={dateRange}
                    setEnablePopup={setEnablePopup}
                    setDateRange={setDateRange}
                    setShowTimeSlots={setShowTimeSlots}
                  />
                ) : (
                  // hotelData?.chainName === "zinc" ||
                  //   hotelData?.chainName === "beacon" ||
                  //   hotelData?.id === 2825 ||
                  //   hotelData?.userId === 106023 ?
                  <BeaconCalendar
                    location={location}
                    dateRange={dateRange}
                    setEnablePopup={setEnablePopup}
                    setDateRange={setDateRange}
                  />
                )
                // :
                // (
                //   <Dates
                //     location={location}
                //     dateRange={dateRange}
                //     setEnablePopup={setEnablePopup}
                //     setDateRange={setDateRange}
                //   />
                // )
              }{" "}
            </div>
          )}
          <div
            style={{ margin: "0px auto", width: "90%" }}
            id="noinventoryRetarg"
          >
            {notifyNoInventory && (
              <div className="noRoomsRetargettingTxtBox">
                <RezylistLoopTxt />
                <button
                  type="button"
                  onClick={() => {
                    setShowInventoryRetargModal(!showInventoryRetargModal);
                    fireGtmEvent("clicked_rezylist_notify_me");
                  }}
                >
                  Notify me
                </button>
              </div>
            )}
          </div>
        </nav>

        {/* PROMOTION */}

        {
          <LazyLoadComponent
            afterLoad={() => fireGtmEvent("promotions_viewed")}
            visibleByDefault={true}
          >
            <Promotion
              isCOD={isCOD}
              isBNPL={isBNPL}
              showCancel={showCancel}
              lastDate={lastDate}
              handleShowHourly={handleShowHourly}
            />
          </LazyLoadComponent>
        }

        {(isCheckin || description?.length > 2) && (
          <div className="landingPage__roomTitle">
            <span>{t("overview")}</span>
          </div>
        )}

        {/* {checkinTimeMsg?.length > 0 && isCheckin && (
          <div
            className="landingPage__description"
            style={{ marginBottom: "-10px" }}
          >
            <h2>{checkinTimeMsg}</h2>
          </div>
        )} */}
        {/* <div className="checkinCheckout">
          <div>
            <span>{t("check_in")}</span>
            <p>{checkInTime}</p>
          </div>
          <div className="verticalLine"></div>
          <div>
            <span>{t("check_out")}</span>
            <p>{checkOutTime}</p>
          </div>
        </div> */}

        {/* DESCRIPTION */}
        {(hotelData?.id === 5153 || hotelData?.id === 27473) &&
        stayType &&
        width <= 550 ? (
          <PropertyOverview hotelImages={HotelImages} stayType={stayType} />
        ) : (
          description?.length > 0 && (
            <div className="landingPage__description">
              {description?.length > 250 ? (
                <div>
                  {description.match(/.{1,250}/g)?.map((des, id) => (
                    <React.Fragment key={id}>
                      {(id < 1 || showMoreDesc) && des?.length > 0 && (
                        <p>
                          {des}
                          {!showMoreDesc ? (
                            <span
                              style={{
                                color: "var(--blueText)",
                                cursor: "pointer",
                                transition:
                                  "text-decoration 0.3s ease, transform 0.3s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.textDecoration = "underline"; // Underline on hover
                                e.target.style.transform = "scale(1.05)"; // Apply scale effect
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.textDecoration = "none"; // Remove underline
                                e.target.style.transform = "scale(1)"; // Revert scale
                              }}
                              onClick={() => {
                                setDescDrawerOpen(true);
                              }}
                            >
                              {` ${t("show_more")}`}
                            </span>
                          ) : (
                            <span
                              style={{ color: "#0078d4", cursor: "pointer" }}
                              onClick={() => setShowMoreDesc(false)}
                            >
                              {` ${t("show_less")}`}
                            </span>
                          )}
                        </p>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              ) : (
                description?.length > 2 && (
                  <p>{formatWithLineBreaks(description)}</p>
                )
              )}
              {/* {description.length > 200 ? (
        <ul>
          {description.match(/.{1,150}/g)?.map((des, id) => (
            <React.Fragment key={id}>
              {(id < 1 || showMoreDesc) && des?.length > 0 && (
                <li>
                  <p>{des}</p>
                </li>
              )}
            </React.Fragment>
          ))}
          {!showMoreDesc ? (
            <p
              style={{ color: "#0078d4", cursor: "pointer" }}
              onClick={() => {
                setDescDrawerOpen(true);
              }}
            >
              {t("show_more")}
            </p>
          ) : (
            <p
              style={{ color: "#0078d4", cursor: "pointer" }}
              onClick={() => setShowMoreDesc(false)}
            >
              {t("show_less")}
            </p>
          )}
        </ul>
      ) : (
        description?.length > 2 && <h2>{description}</h2>
      )} */}

              {anirudhWhatsappNumber.includes(id) ? (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`https://wa.me/+919845453940?text=Hello%20${name}%20I found your property through hotelzify`}
                  onClick={() => sendWhatsappClick()}
                >
                  <img
                    src="https://ik.imagekit.io/hotelzifyprod/whatsapp-logo-4456%20(1)_Cj-R_s4dB.png"
                    alt={name + " whatsapp contact"}
                    width={"50"}
                    height={"50"}
                  />
                </a>
              ) : excludedProperties.includes(id) ? (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`https://wa.me/+919740049200?text=Hello%20${name}%20I found your property through hotelzify`}
                  onClick={() => sendWhatsappClick()}
                >
                  <img
                    src="https://ik.imagekit.io/hotelzifyprod/whatsapp-logo-4456%20(1)_Cj-R_s4dB.png"
                    alt={name + " whatsapp contact"}
                    width={"50"}
                    height={"50"}
                  />
                </a>
              ) : // : hotelData?.id === 5158 ? (
              //   <a
              //     target="_blank"
              //     rel="noreferrer"
              //     href={`https://wa.me/+919663113077?text=Hello%20${name}%20I found your property through hotelzify`}
              //     onClick={() => sendWhatsappClick()}
              //   >
              //     <img
              //       src="https://ik.imagekit.io/hotelzifyprod/whatsapp-logo-4456%20(1)_Cj-R_s4dB.png"
              //       alt={name + " whatsapp contact"}
              //       width={"50"}
              //       height={"50"}
              //     />
              //   </a>
              // )

              hotelData?.id === 26303 ||
                hotelData?.id === 27472 ||
                hotelData?.id === 27473 ? (
                <div className="floating_call_whatsapp">
                  <a className="rosa-a" href="tel:+917042933155">
                    <img
                      alt={name + " call"}
                      src="https://ik.imagekit.io/hotelzifyprod/call_logo_blue_d430c518-502f-442f-accf-b1baa7bc1256.png"
                      width={"50"}
                      height={"50"}
                      style={{ borderRadius: "50%" }}
                    />
                  </a>
                  <a
                    className="rosa-a"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://wa.me/+918287264525?text=Hello%20${name}%20I found your property through hotelzify`}
                    onClick={() => sendWhatsappClick()}
                  >
                    <img
                      src="https://ik.imagekit.io/hotelzifyprod/whatsapp-logo-4456%20(1)_Cj-R_s4dB.png"
                      alt={name + " whatsapp contact"}
                      width={"50"}
                      height={"50"}
                      style={{ borderRadius: "50%" }}
                    />
                  </a>
                </div>
              ) : hotelData?.id === 4680 ? (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`https://wa.me/+917022198813?text=Hello%20${name}%20I found your property through hotelzify`}
                  onClick={() => sendWhatsappClick()}
                >
                  <img
                    src="https://ik.imagekit.io/hotelzifyprod/whatsapp-logo-4456%20(1)_Cj-R_s4dB.png"
                    alt={name + " whatsapp contact"}
                    width={"50"}
                    height={"50"}
                  />
                </a>
              ) : domain &&
                (whatsappNumber !== null || whatsappNumber?.length > 0) ? (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`https://wa.me/${whatsappDial}${whatsappNumber}?text=Hello%20${name}%20I found your property through hotelzify`}
                  onClick={() => sendWhatsappClick()}
                >
                  <img
                    src="https://ik.imagekit.io/hotelzifyprod/whatsapp-logo-4456%20(1)_Cj-R_s4dB.png"
                    alt={name + " whatsapp contact"}
                    width={"50"}
                    height={"50"}
                  />
                </a>
              ) : null}
            </div>
          )
        )}

        {/* {[5151, 10].includes(hotelData?.id) ? (
          <div
            style={{
              position: "fixed",
              top: "60%",
              right: "0",
              display: "flex",
              padding: "10px",
              zIndex: "2001",
              cursor: "pointer",
              borderRadius: "5px 0 0 5px",
              background: "linear-gradient(#008000, #90EE90)",
            }}
            onClick={() => {
              setBotDrawerOpen(true);
              fireGtmEvent("call_ai_button_clicked");
            }}
          >
            <img
              src={phoneImg}
              alt="Phone Icon"
              style={{ color: "green", width: "25px" }}
            />
          </div>
        ) : null} */}

        <Drawer isOpen={isBotDrawerOpen} setIsOpen={setBotDrawerOpen}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              maxHeight: "500px",
            }}
          >
            {/* Header Section */}
            <div
              style={{
                position: "sticky",
                top: 0,
                left: 0,
                right: 0,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: "5px 10px",
                // backgroundColor: "#fff",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                zIndex: 1000,
              }}
            >
              <div>
                <p
                  style={{
                    color: "#000",
                    leadingTrim: "both",
                    textEdge: "cap",
                    font1family: "Manrope",
                    // fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  Sure, please give us your phone number
                </p>
                {/* <p
                  style={{
                    color: "var(--Grey, 808080)",
                    leadingTrim: "both",
                    textEdge: "cap",
                    font1family: "Manrope",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "normal",
                  }}
                >
                  with dialcode(ex:+91923XXXXXXX)
                </p> */}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => setBotDrawerOpen(false)} // Close the drawer
              >
                <img
                  alt="close modal"
                  src="https://ik.imagekit.io/hotelzifyprod/cross_rgYPtv6N7.svg"
                  width={20}
                  height={20}
                />
              </div>
            </div>

            {/* Input and Call Button */}
            <div
              style={{
                padding: "20px",
                overflowY: "auto",
                flexGrow: 1,
              }}
            >
              <label>Enter phone</label>
              <input
                type="text"
                value={phoneNumber}
                onChange={(e) => {
                  setPhoneNumber(e.target.value);
                  fireGtmEvent("entered_details");
                }}
                placeholder="with dialcode (ex:+91923XXXXXXX)"
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "20px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              />
              <button
                onClick={handleCallBot}
                style={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: isCalling ? "#ccc" : "#4CAF50",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: isCalling ? "not-allowed" : "pointer",
                }}
                disabled={isCalling} // Disable button during API call
              >
                {isCalling ? "Calling..." : "Call me"}
              </button>
            </div>
          </div>
        </Drawer>

        <Drawer
          isOpen={isDescDrawerOpen}
          setIsOpen={setDescDrawerOpen}
          // width="700px"
          // height="500px"
          overflow="hidden"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              maxHeight: "500px",
            }}
          >
            <div
              style={{
                position: "sticky",
                top: 0,
                left: 0,
                right: 0,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: "5px 10px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                zIndex: 1000,
              }}
            >
              <h2 className="uppercase">{t("Description")}</h2>

              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  alt="close modal"
                  src="https://ik.imagekit.io/hotelzifyprod/cross_rgYPtv6N7.svg"
                  width={20}
                  height={20}
                  onClick={() => setDescDrawerOpen(!isDescDrawerOpen)}
                />
              </div>
            </div>

            <div
              style={{
                padding: "20px",
                overflowY: "auto",
                flexGrow: 1,
                // height: "calc(100% - 60px)",
              }}
            >
              {/* {description?.split(/\n\s*\n/).map((para, index) => (
                // <p key={index}>{para}</p>
                // <p>{formatWithLineBreaks(para)}</p>
                <Markdown>{para}</Markdown>
              ))} */}
              {description?.split(/\n\s*\n/).map((para, idx) => (
                <p
                  key={idx}
                  style={{ marginBottom: "1rem", whiteSpace: "pre-wrap" }}
                >
                  {para.split("\n").map((line, lineIdx) => (
                    <React.Fragment key={lineIdx}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              ))}
            </div>
          </div>
        </Drawer>
        <div className="landingPage__Amenities" id="hotelAmenities">
          {hotelData?.currency !== "USD" &&
            hotelData?.id !== 26999 &&
            hotelData?.userId !== 106023 &&
            hotelData?.id !== 392 &&
            hotelData?.id !== 29916 &&
            policies
              ?.filter(
                (pol) => pol?.category === "Unmarried couples are allowed"
              )
              ?.some((pol) => pol?.HotelPolicies?.length) &&
            (policies
              ?.filter(
                (pol) => pol?.category === "Unmarried couples are allowed"
              )
              ?.some((pol) => pol?.HotelPolicies[0]?.variables?.isAllowed) ||
            policies
              ?.filter(
                (pol) => pol?.category === "Unmarried couples are allowed"
              )
              ?.some((pol) => pol?.HotelPolicies?.length === 0) ||
            HotelAmenities?.some(
              (amn) => amn?.Amenity?.name === "Couple Friendly"
            ) ? (
              <div
                style={{
                  margin: "10px auto",
                  padding: "10px ",
                  width: "90%",
                  background: "#3395ff0f",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  borderRadius: "8px",
                }}
              >
                {/* https://ik.imagekit.io/hotelzifyprod/65f055bd-2fe0-4b98-8153-54e6685bcdfa.webp */}
                <img
                  src="https://ik.imagekit.io/hotelzifyprod/7f6202c3-d322-40fd-b110-cd914bf87296.svg"
                  alt="couple friendly"
                  width={50}
                  height={50}
                />
                <p style={{ fontSize: "14px" }}>{t("couple_friendly")}</p>
              </div>
            ) : (
              <div
                style={{
                  margin: "10px auto",
                  padding: "10px ",
                  width: "90%",
                  background: "#3395ff0f",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  borderRadius: "8px",
                }}
              >
                <img
                  src="https://ik.imagekit.io/hotelzifyprod/417e9918-911c-4c73-a33a-a698b79ea061.png"
                  alt="couple friendly"
                  width={"100%"}
                  height={"100%"}
                  style={{ width: "50px", height: "50px" }}
                />
                <p style={{ fontSize: "14px" }}>
                  {t("unmarried_couples_not_allowed")}
                </p>
              </div>
            ))}
        </div>

        {/* AMENITIES */}
        {HotelAmenities?.length > 0 && (
          <LazyLoadComponent
            visibleByDefault={true}
            afterLoad={() => fireGtmEvent("amenities_viewed")}
          >
            <div className="landingPage__roomTitle" ref={amenityRef}>
              <span>{t("facilities")}</span>
            </div>

            <div className="landingPage__Amenities" id="hotelAmenities">
              {hotelData?.acceptanceRate > 90 ? (
                <div className="acceptaneRateBanner">
                  <div className="arImgSection">
                    <div className="acceptanceRateImg">
                      <img
                        src={leftFeather}
                        alt="left feather"
                        width={"100%"}
                        height={"100%"}
                      />
                      <p>GUEST FAVOURITE</p>
                      <img
                        src={rightFeather}
                        alt="right feather"
                        width={"100%"}
                        height={"100%"}
                      />
                    </div>
                  </div>
                  <div className="acceptanceRateText">
                    <p>Book now for a guaranteed stay</p>
                  </div>
                </div>
              ) : null}

              <div className="landingPage__amenityList">
                {HotelAmenities?.map(
                  (amn, id) =>
                    id < 8 && (
                      <span key={id}>
                        {amn?.Amenity?.cdnImageUrl?.length > 0 ? (
                          <img
                            loading="lazy"
                            width={"30px"}
                            height={"30px"}
                            src={amn?.Amenity?.cdnImageUrl}
                            alt={amn?.Amenity?.name}
                            className="landingPage__Amenity"
                          />
                        ) : (
                          "•"
                        )}{" "}
                        {amn?.Amenity?.Transalations?.[0]?.name ||
                          amn?.Amenity?.name}
                      </span>
                    )
                )}
              </div>
              <Drawer
                isOpen={isDrawerOpen}
                setIsOpen={setDrawerOpen}
                width="fit-content"
                height="500px"
                overflow="hidden" // Ensure the Drawer doesn't overflow
              >
                <div style={{ position: "relative", height: "100%" }}>
                  <div
                    style={{
                      position: "sticky", // Stick the header to the top
                      top: 0,
                      left: 0,
                      right: 0,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      padding: "5px 10px",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      zIndex: 1000,
                    }}
                  >
                    <h2>{t("amenities")}</h2>
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        alt="close modal"
                        src="https://ik.imagekit.io/hotelzifyprod/cross_rgYPtv6N7.svg"
                        width={20}
                        height={20}
                        onClick={() => setDrawerOpen(!isDrawerOpen)}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      padding: "20px",
                      overflowY: "auto",
                      display: "grid",
                      gridTemplateColumns:
                        width > 901 ? "repeat(3,1fr)" : "repeat(2, 1fr)",
                      // gap: "8px",
                      padding: "10px",
                      overflowY: "auto",
                      height: "calc(100% - 60px)",
                    }}
                  >
                    {HotelAmenities?.map((amn, id) => (
                      <span
                        key={id}
                        style={{
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                      >
                        {amn?.Amenity?.cdnImageUrl?.length > 0 ? (
                          <img
                            loading="lazy"
                            width={"30px"}
                            height={"30px"}
                            src={amn?.Amenity?.cdnImageUrl}
                            alt={amn?.Amenity?.name}
                            className="landingPage__Amenity"
                            style={{ marginRight: "5px" }}
                          />
                        ) : (
                          "•"
                        )}{" "}
                        {amn?.Amenity?.Transalations?.[0]?.name ||
                          amn?.Amenity?.name}
                      </span>
                    ))}
                  </div>
                </div>
              </Drawer>

              {HotelAmenities?.length > 8 && (
                <p
                  style={{
                    width: "100%",
                    textAlign: "center",
                    color: "var(--blueText)",
                    // color: "#0078d4",
                    fontWeight: "bold",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                    transition:
                      "text-decoration 0.3s ease, transform 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.textDecoration = "underline"; // Underline on hover
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.textDecoration = "none"; // Remove underline
                  }}
                  onClick={() => {
                    setDrawerOpen(true);

                    // allAmenities
                    //   ? fireGtmEvent("amenity_less_clicked")
                    //   : fireGtmEvent("amenity_more_clicked");
                    // setAllAmenities(!allAmenities);
                  }}
                >
                  {allAmenities
                    ? t("show_less")
                    : `${t("show_all")} ${HotelAmenities?.length} ${t(
                        "amenities"
                      )}`}
                </p>
              )}
            </div>
          </LazyLoadComponent>
        )}

        <div
          className="landingPage__roomTitle"
          ref={roomsRef}
          id="scrollToTopSection"
        >
          <span>{t("rooms")}</span>
        </div>

        {showHourly &&
          (isHourlyRoom ? (
            <div
              className="landingPageHourly"
              style={{ padding: "10px 20px" }}
              onClick={handleShowHourly}
            >
              {t("book_for_full_night")} 🌙
            </div>
          ) : (
            <div
              className="landingPageHourly newHrBg"
              onClick={handleShowHourly}
            >
              <div className="newHrBannerLeft">
                <p>{t("introducing_hourly_stays")}</p>
                <div className="newHrFooter">
                  <p>{t("book_for")}</p>
                  <p className="time">3h</p>
                  <p className="time">6h</p>
                  <p className="time">12h</p>{" "}
                </div>
              </div>

              <div className="newHrBannerRight">
                <img
                  src="https://ik.imagekit.io/hotelzifyprod/feef7b4d-3455-4542-a5a1-9ba139b7a4f4.png?tr=w-600,h-600"
                  alt="hourly stays"
                  width={"100%"}
                  height={"100%"}
                />
                <div className="hrBtn">{t("book_now")}</div>
              </div>

              {/* <img
                src="https://ik.imagekit.io/hotelzifyprod/fa920d13-d58f-4bba-8549-afb4a7d32d3a.svg"
                alt=""
              /> */}

              {/* <div className="hourlyButton">
                Click Here For Hourly Bookings! ⏰
              </div> */}
            </div>
          ))}

        <LazyLoadComponent
          afterLoad={() => {
            fireGtmEvent("rooms_viewed");
            setEventCount((state) => state + 1);
          }}
        >
          <div style={{ display: "none" }}></div>
        </LazyLoadComponent>

        {/* <div className="landingPage__Amenities" style={{ background: "none" }}>
          <WeekView dateRange={dateRange} setDateRange={setDateRange} />
        </div> */}
        <div className="displayRoom">
          {Array.isArray(sortedRooms) && isHourlyRoom
            ? sortedRooms
                ?.filter((rm) => rm?.hourly?.length > 0)
                ?.map((room, idx) => (
                  <>
                    {/* <div key={room.id} id={`6room-${room.id}`}> */}
                    <Room
                      key={room.id}
                      room={room}
                      extraPrice={1 || localExtraValue}
                      lastDates={lastDate}
                      totalPeople={totalPeople}
                      dateRange={dateRange}
                      // showFakePrice={showFakePrice}
                      showFakePrice={false}
                      isFirst={idx === 0}
                      showLoyal={setShowLoyalty}
                      handleRoomPrice={handleRoomPrice}
                      pricingfornotifications={pricingfornotifications}
                      getSecretMemberDealUrl={getSecretMemberDealUrl}
                      applyPromotion={applyPromotion}
                      promotionRes={promotionRes}
                      adults={adults}
                      child={child}
                    />
                    {/* </div> */}
                  </>
                ))
            : sortedRooms?.map((room, idx) => (
                <>
                  {/* <div key={room.id} id={`room-${room.id}`}> */}
                  <Room
                    key={room.id}
                    extraPrice={1 || localExtraValue}
                    room={room}
                    lastDates={lastDate}
                    totalPeople={totalPeople}
                    dateRange={dateRange}
                    showFakePrice={false}
                    // showFakePrice={showFakePrice}
                    isFirst={idx === 0}
                    showLoyal={setShowLoyalty}
                    handleRoomPrice={handleRoomPrice}
                    pricingfornotifications={pricingfornotifications}
                    getSecretMemberDealUrl={getSecretMemberDealUrl}
                    applyPromotion={applyPromotion}
                    promotionRes={promotionRes}
                    adults={adults}
                    child={child}
                  />
                  {/* </div> */}
                </>
              ))}
        </div>

        {/* Owner info */}

        {ownerDetails?.imageUrl?.length > 0 && (
          <div className="ownerInfoContainer">
            <div
              className="landingPage__roomTitle"
              ref={ownerInfoRef}
              style={{
                padding: "0",
                margin: "10px 0",
                fontSize: "1.2rem !important",
              }}
            >
              <span>{t("about_us")}</span>
            </div>
            <div className="ownerInfo">
              <img
                src={ownerDetails?.cdnImageUrl}
                alt={`${name} owner`}
                width={60}
                height={60}
              />
              <h3>
                {ownerDetails?.name},{" "}
                <span style={{ fontWeight: "normal" }}>{t("your_host")}</span>
              </h3>
            </div>
            <div className="ownerInfoDescription">
              {ownerDetails?.description} {t("best_service_offers")}
            </div>
          </div>
        )}
        {ownerDetails?.id && (
          <LazyLoadComponent
            afterLoad={() => {
              fireGtmEvent("owner_info_viewed");
              setEventCount((state) => state + 1);
            }}
          >
            <div style={{ display: "none" }}></div>
          </LazyLoadComponent>
        )}

        {/* Hotel Addons */}

        {HotelAddons?.length > 0 && (
          <div className="landingPage__roomTitle">
            <span>{t("addons")}</span>
            {(width > 900
              ? HotelAddons?.length > 2
              : HotelAddons?.length > 1) && (
              <span className="scrollBtns">
                {" "}
                <img
                  src={right}
                  alt="scroll left"
                  onClick={() => scrollAddon(-200)}
                  style={{ transform: "rotate(180deg)" }}
                  height="100%"
                  width={"20px"}
                />{" "}
                <img
                  src={right}
                  alt="scroll right"
                  height="100%"
                  width={"20px"}
                  onClick={() => scrollAddon(200)}
                />
              </span>
            )}
          </div>
        )}

        {Array.isArray(HotelAddons) && HotelAddons?.length > 0 && (
          <LazyLoadComponent
            afterLoad={() => fireGtmEvent("hotel_addons_viewed")}
            visibleByDefault={true}
          >
            <div className="hotelLevelAddon" ref={hotelAddonRef}>
              {HotelAddons?.map((adn, idx) => (
                <HotelAddonComponent key={idx} addon={adn} />
              ))}
            </div>
          </LazyLoadComponent>
        )}

        {hotelData?.userId === 63809 && (
          <div
            className="hotelLevelAddon"
            ref={postRef}
            onClick={() => {
              fireGtmEvent("insta_clicked");
            }}
          >
            <Instaposts />
          </div>
        )}

        {/* Trip Planner */}

        <LazyLoadComponent afterLoad={() => fireGtmEvent("tripPlanner_viewed")}>
          <div className="tripContainer">
            <Link
              to={`/planner/${id}`}
              className="tripPlannerButton"
              onClick={() => fireGtmEvent("planner_clicked")}
            >
              <p>{t("slay_travel_itinerary")}✨✈️</p>
              <span>{t("generate_in_seconds")}</span>

              <img
                src={
                  rightArrow //"https://ik.imagekit.io/hotelzifyprod/58caca48-900b-48a3-a769-b14cb64a12ab.png"
                }
                loading="lazy"
                alt="planner image"
                className="itineraryImg"
                width={"50px"}
                height="100%"
              />
              <img
                src={overflowImg}
                loading="lazy"
                alt="planner image"
                width={"100%"}
                height="100%"
                className="overflowImg"
              />
            </Link>
          </div>
        </LazyLoadComponent>

        {/* MAP  */}
        <LazyLoadComponent
          afterLoad={() => {
            fireGtmEvent("maps_viewed");
            setEventCount((state) => state + 1);
          }}
        >
          <div className="landingPage__roomTitle">
            <span>{t("map")}</span>
          </div>
        </LazyLoadComponent>

        {/* <LazyLoadComponent >
          <div className="landingPage__Map">
            {latitude && longitude && (
              <Map2
                name={name}
                lat={latitude}
                long={longitude}
                address={address}
              />
            )}
          </div>
        </LazyLoadComponent> */}

        {/* <LazyLoadComponent > */}
        <div className="landingPage__Map" ref={mapRef}>
          <GoogleMap2
            name={removeSpecialCharacters(hotelData?.name)}
            address={removeSpecialCharacters(hotelData?.address)}
          />
        </div>
        {/* </LazyLoadComponent> */}

        {nearbyPlaces?.length > 0 && (
          <LazyLoadComponent
            afterLoad={() => fireGtmEvent("nearbyplaces_viewed")}
          >
            <div className="landingPage__roomTitle">
              <span>{t("nearby_places")}</span>
              {nearbyPlaces.length > 7 && (
                <p
                  style={{
                    fontSize: "0.8rem",
                    color: "#0078d4",
                    fontWeight: "normal",
                  }}
                  onClick={() => {
                    setShowMorePlace(!showMorePlace);
                    fireGtmEvent("maps_show_more_clicked");
                  }}
                >
                  {!showMorePlace ? t("show_more") : t("show_less")}
                </p>
              )}
            </div>
          </LazyLoadComponent>
        )}

        {nearbyPlaces?.map((place, id) => {
          try {
            var lt = place?.latitude || place?.geometry?.location?.lat || 0;
            var ln = place?.longitude || place?.geometry?.location?.lng || 0;
          } catch (e) {}
          return (
            (id < 7 || showMorePlace) && (
              <div className="landingPage__nearby" key={id} id="nearbyPlaces">
                <span>• {place?.name}</span>
                <span>
                  {place?.distance
                    ? place?.distance
                    : distanceCalculation(
                        latitude,
                        longitude,
                        lt,
                        ln,
                        hotelData?.currency === "USD"
                      )}{" "}
                  {place?.distanceUnit
                    ? place?.distanceUnit
                    : hotelData?.currency === "USD"
                    ? "mi"
                    : "km"}
                </span>
              </div>
            )
          );
        })}

        {/* <NearbyPlaces places={nearbyPlaces} lat1={latitude} lon1={longitude} /> */}

        {/* <a
          className="viewMapBtn"
          rel="noreferrer"
          href={`https://www.google.com/maps?q=${latitude},${longitude}`}
          target="_blank"
        >
          {t("view_in_maps")}
        </a> */}

        {/* SOCIAL POSTS */}

        {instaLinks?.length > 0 && (
          <LazyLoadComponent>
            <>
              <div
                className="landingPage__roomTitle"
                style={{ justifyContent: "center" }}
              >
                <img
                  src="https://ik.imagekit.io/hotelzifyprod/d8cf069a-9cad-49ad-bc82-9545c5acc104.jpg"
                  alt="instagram logo"
                  loading="lazy"
                  width="100%"
                  height="100%"
                />
              </div>

              <div className="instagramPosts" id="instagramPosts">
                {instaLinks?.map(
                  (link, id) =>
                    id < 6 && (
                      <img
                        key={link}
                        src={link}
                        alt="instagram post"
                        loading="lazy"
                        onClick={() => handleImage(id)}
                      />
                    )
                )}
              </div>
            </>
          </LazyLoadComponent>
        )}

        {viewImage && (
          <ReactSimpleImageViewer
            src={instaLinks}
            currentIndex={currentIndex}
            disableScroll={false}
            closeOnClickOutside={true}
            onClose={setViewImage}
          />
        )}

        {/* Reviews */}

        {sortedReviews?.length > 0 &&
          sortedReviews?.some((rv) => rv?.rating.value > 3) && (
            <>
              <div className="landingPage__roomTitle" ref={reviewRef}>
                <span
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontFamily: "Plus Jakarta Sans",
                    fontSize: "20px",
                    fontWeight: "500px",
                  }}
                >
                  {t("reviews")}
                </span>
              </div>
              <LazyLoadComponent
                afterLoad={() => fireGtmEvent("reviews_viewed")}
                visibleByDefault={true}
              >
                {" "}
                <div>
                  <div className="container_div">
                    <div className="functioanlitiesDiv">
                      <div
                        className="sortForReviews"
                        onClick={() => setIsSortOpen(!isSortOpen)}
                      >
                        <span className="material-symbols-outlined sortSign">
                          sort
                        </span>
                        <div
                          style={{
                            paddingLeft: "5px",
                          }}
                        >
                          Sort
                        </div>
                      </div>
                    </div>

                    {isSortOpen && (
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        className="SortDropDown"
                      >
                        <div>
                          <input
                            type="checkbox"
                            value="5"
                            id="mostRelevant"
                            style={{ cursor: "pointer" }}
                            checked={valueforSelectedOption === "5"}
                            onChange={handleSortChange}
                          />
                          <label
                            htmlFor="mostRelevant"
                            style={{
                              marginLeft: "6px",
                              color:
                                valueforSelectedOption === "5"
                                  ? "blue"
                                  : "#494545",
                              cursor: "pointer",
                            }}
                          >
                            Most Relevant
                          </label>
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            id="newEst"
                            value="0" //for newest sorting option
                            checked={valueforSelectedOption === "0"}
                            onChange={handleSortChange}
                            style={{ cursor: "pointer" }}
                          />
                          <label
                            htmlFor="newEst"
                            style={{
                              marginLeft: "6px",
                              color:
                                valueforSelectedOption === "0"
                                  ? "blue"
                                  : "#494545",
                              cursor: "pointer",
                            }}
                          >
                            Newest
                          </label>
                        </div>
                      </div>
                    )}
                    <p
                      className="clearAll"
                      onClick={() => {
                        setValueforSelectedOption(null);
                        setIsSortOpen(false);
                        setAskingForsortedReviewsTimeStampVise(false);
                      }}
                      style={{ paddingLeft: "35px" }}
                    >
                      Clear All
                    </p>
                  </div>
                </div>
                <hr className="horizontalLine" />
                {isLoading ? (
                  <div className="Reviewsloader">Loading Reviews...</div>
                ) : (
                  <div
                    className="landingPageReviews"
                    id="landingPageReviews"
                    ref={reviewRef}
                  >
                    {sortedReviews?.map((rv, index) => {
                      const propTimeStamp =
                        new Date(rv.timestamp) < benchmarkDate
                          ? dayjs(defaultTimeStamp).fromNow()
                          : dayjs(rv.timestamp).fromNow();
                      return (
                        rv?.rating.value >= 3 && (
                          <Review
                            key={index}
                            index={index}
                            rview={rv}
                            // name={name}
                            // address={address}
                            // images={HotelImages}
                            newReviews={sortedReviews.filter(
                              (review) => review.rating.value >= 3
                            )}
                            timeStamp={propTimeStamp}
                          />
                        )
                      );
                    })}
                  </div>
                )}
              </LazyLoadComponent>
            </>
          )}
        {
          //Code for scroll buttons after reviews
          /*(
                  {reviews?.reviews?.filter((rv) => rv?.rating > 3)?.length ||null}
                  ) <- this has been removed from here as in the new design we are not showing the number of reviews*/
          /*meaning of below code , 
                  
                  if (screen width is >900 filter the review array and return such an array that contains reviews with ratings>3 and then check the length of the array, only move ahead to scroll buttons if the length of the array is>3)
                  
                  else (screen width is <=900 filter the review array and return such an array that contains reviews with rating >3 and then check the length of the array, only move ahead to scroll buttons if the length of the array is >2)
                  */

          (width > 900
            ? sortedReviews?.filter((rv) => rv?.rating.value > 3)?.length > 4
            : //Arjun changed this, earlier this was length > 3, since now we are displaying 4 on 1 screen
              sortedReviews?.filter((rv) => rv?.rating.value > 3)?.length >
              2) &&
            //code for scoll buttons starts here
            isLoading !== true && (
              <div className="ReviewscrollBtns">
                {" "}
                <div
                  onClick={() => scrollReview(-400)}
                  className="ReviewPrevButton"
                >
                  <img
                    src={prevReview}
                    alt="scroll left"
                    // check scrollReview
                    // style={{ transform: "rotate(180deg)" }}
                  />
                  <p>Prev</p>
                </div>{" "}
                <div
                  onClick={() => scrollReview(400)}
                  className="ReviewNextButton"
                >
                  <p>Next</p>

                  <img src={nextReview} alt="scroll right" />
                </div>
              </div>
            )
        }

        {/* Cancel Booking */}

        {showCancelPopup && (
          <div className="mainPage__cancelBooking">
            <div className="cancelBooking__container">
              <div className="landingPage__roomTitle">
                <span>{t("cancel_booking")}</span>{" "}
                <span
                  onClick={() => {
                    setShowCancelPopup(false);
                    setCancelPhone("");
                    setCancelId("");
                    setShowCancelBtn(false);
                    setCancelData(null);
                    setShowNoBook(false);
                  }}
                >
                  X
                </span>
              </div>
              <div className="cancelPhone">
                <PhoneInput
                  defaultCountry={
                    storageService.get("country_code") ||
                    hotelData?.country ||
                    "IN"
                  }
                  name="phone"
                  placeholder="Please enter phone number"
                  value={cancelPhone}
                  onChange={(val) => setCancelPhone(val)}
                  disabled={showCancelBtn}
                  style={{
                    border: "none",
                    "--react-international-phone-country-selector-background-color":
                      "transparent",
                    "--react-international-phone-dropdown-background": "none",
                  }}
                />
              </div>
              <div className="cancelPhone">
                <input
                  type="number"
                  value={cancelId}
                  placeholder="Enter Booking ID"
                  onChange={(e) => setCancelId(e.target.value)}
                  disabled={showCancelBtn}
                />
              </div>

              <div className="cancelBtn" onClick={() => handelCancelBooking()}>
                {t("verify")}
              </div>

              {cancelData?.id > 0 ? (
                <div className="cancelBookingInfo">
                  <div className="cancelRow">
                    <p>{t("total_amount")}</p>
                    <p>
                      {cancelData?.totalAmount} {currency(hotelData?.currency)}
                    </p>
                  </div>
                  <div className="cancelRow">
                    <p>{t("amount_paid")}</p>
                    <p>
                      {cancelData?.amountPaid} {currency(hotelData?.currency)}
                    </p>
                  </div>
                  {cancelData?.convenienceFee &&
                  cancelData?.convenienceFee > 0 ? (
                    <div className="cancelRow">
                      <div
                        style={{
                          display: "flex",
                          gap: "2px",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            color: "black",
                            fontSize: "14px",
                          }}
                        >
                          {t("convenience_fee")}
                        </p>

                        <div
                          className="tooltip-container"
                          style={{
                            position: "relative",
                            display: "inline-block",
                            // cursor: "help",
                          }}
                          onMouseEnter={(e) => {
                            const tooltip =
                              e.currentTarget.querySelector(".tooltip-text");
                            if (tooltip) {
                              tooltip.style.visibility = "visible";
                              tooltip.style.opacity = "1";
                            }
                          }}
                          onMouseLeave={(e) => {
                            const tooltip =
                              e.currentTarget.querySelector(".tooltip-text");
                            if (tooltip) {
                              tooltip.style.visibility = "hidden";
                              tooltip.style.opacity = "0";
                            }
                          }}
                        >
                          <span
                            style={{
                              color: "black",
                              fontSize: "12px",
                              border: "1px solid black",
                              borderRadius: "50%",
                              width: "16px",
                              height: "16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "bold",
                            }}
                          >
                            ?
                          </span>
                          <div
                            className="tooltip-text"
                            style={{
                              visibility: "hidden",
                              opacity: 0,
                              minWidth: "200px",
                              maxWidth: "90vw",
                              backgroundColor: "#333",
                              color: "#fff",
                              textAlign: "left",
                              borderRadius: "6px",
                              padding: "8px 12px",
                              position: "absolute",
                              zIndex: 1000,
                              top: "50%",
                              // left: "25px",
                              transform: "translateY(-50%)",
                              fontSize: "12px",
                              transition: "opacity 0.3s ease",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                              pointerEvents: "none",
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}
                          >
                            {t("processing_fee_notice")}
                          </div>
                        </div>
                      </div>

                      <p style={{ color: "black", fontSize: "14px" }}>
                        {cancelData?.convenienceFee}{" "}
                        {currency(hotelData?.currency)}
                      </p>
                    </div>
                  ) : null}

                  <div className="cancelRow">
                    <p
                      style={{
                        color: "red",
                      }}
                    >
                      {t("refund_amount")}
                    </p>
                    <p style={{ color: "red" }}>
                      {cancelData?.refundAmount} {currency(hotelData?.currency)}
                    </p>
                  </div>
                  {/* {cancelData?.paymentStatus === "Fully Paid Online" &&
                    cancelData?.convenienceFee > 0 && (
                      <div className="cancelRow">
                        <p
                          style={{
                            color: "#e67e22",
                            fontSize: "14px",
                          }}
                        >
                          {t("processing_fee_notice")}{" "}
                        </p>
                      </div>
                    )} */}
                  <div
                    className="cancelRow"
                    style={{ flexDirection: "column", gap: "10px" }}
                  >
                    <p>{t("cancel_confirmation")} </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        color: "#fff",
                        width: "100%",
                      }}
                    >
                      <button
                        style={{
                          width: "30%",
                          color: "#fff",
                          background: "red",
                          borderRadius: "4px",
                          textAlign: "center",
                          padding: "8px",
                          cursor: "pointer",
                        }}
                        disabled={isCancelling}
                        onClick={cancelBookingById}
                      >
                        {isCancelling ? "Cancelling.." : t("yes_option")}
                      </button>
                      <button
                        style={{
                          width: "30%",
                          color: "#fff",
                          background: "green",
                          borderRadius: "4px",
                          textAlign: "center",
                          padding: "8px",
                          cursor: "pointer",
                        }}
                        disabled={isCancelling}
                        onClick={() => {
                          setShowCancelPopup(false);
                          setCancelPhone("");
                          setCancelId("");
                          setShowCancelBtn(false);
                          setCancelData(null);
                          setShowNoBook(false);
                        }}
                      >
                        {t("no_option")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                showNoBook && (
                  <div className="cancelNoBooking">
                    {cancelError || t("no_booking_found")}
                  </div>
                )
              )}
            </div>
          </div>
        )}

        {showModifyPopup && (
          <div className="mainPage__cancelBooking">
            <div
              className="cancelBooking__container"
              style={{ width: "fit-content" }}
            >
              <div
                className="landingPage__roomTitle"
                style={{ width: "100%", padding: "0" }}
              >
                <span>Modify Booking</span>
                <span
                  onClick={() => {
                    setModifyPopup(false);
                    setCancelId("");
                  }}
                >
                  X
                </span>
              </div>

              <div className="cancelPhone">
                <input
                  type="number"
                  value={cancelId}
                  placeholder="Enter Booking ID"
                  onChange={(e) => setCancelId(e.target.value)}
                  disabled={showCancelBtn}
                />
              </div>

              <div
                className="cancelBtn"
                style={{ width: "100%" }}
                onClick={handleModify}
              >
                Modify
              </div>
            </div>
          </div>
        )}

        {enablePopup && (
          <SelectRooms
            setEnablePopup={setEnablePopup}
            location={location}
            setAdults={setAdults}
            adults={adults}
            room={room}
            dateRange={dateRange}
            child={child}
            setRoom={setRoom}
            setChild={setChild}
            infant={infant}
            setInfant={setInfant}
            fetchOnClick={fetchOnClick}
            roomsRef={roomsRef}
            isHourlyRoom={isHourlyRoom}
            hotelData={hotelData}
          />
        )}

        {/* FAQ */}

        {/* FAQ SECTION */}
        {faqs?.length > 0 && (
          <div className="landingPage__roomTitle" ref={faqRef}>
            <span>
              {t("faq_title")} ({faqs?.length})
            </span>
          </div>
        )}
        <FAQ />

        <>
          <LazyLoadComponent afterLoad={() => fireGtmEvent("rules_viewed")}>
            <div
              className="landingPage__roomTitle"
              style={{ marginBottom: "-15px" }}
            >
              <span>{t("property_rules_title")}</span>
            </div>
            <div className="checkinCheckout">
              <div>
                {/* <span>{t("check_in")}</span> */}

                <span>{t(getTextKey(hotelData?.userId, "check_in"))}</span>
                <p>{checkInTime}</p>
              </div>
              <div className="verticalLine"></div>
              <div>
                <span>{t(getTextKey(hotelData?.userId, "check_out"))}</span>
                <p>{checkOutTime}</p>
              </div>
            </div>
          </LazyLoadComponent>

          <div className="propertyRules" id="propertyRules">
            <ul style={{ listStyle: "disc" }}>
              {houseRules?.map((ru, id) => {
                return ru?.HotelPolicies?.length > 0 ? (
                  ru.uiType === "custom" ? (
                    ru?.HotelPolicies?.filter(
                      (x) => x?.variables?.isAllowed
                    )?.map((poli) => <li key={id}>{poli?.policies}</li>)
                  ) : ru?.HotelPolicies[0]?.variables?.isAllowed ? (
                    <li key={id}>
                      {ru?.Transalations?.variables?.[0]?.isAllowed ||
                        ru?.variables[0]?.isAllowed}
                    </li>
                  ) : (
                    <li key={id}>
                      {ru?.Transalations?.variables?.[0]?.isNotAllowed ||
                        ru?.variables[0]?.isNotAllowed}
                    </li>
                  )
                ) : (
                  <li key={id}>
                    {ru?.Transalations?.variables?.[0]?.isAllowed ||
                      ru?.variables[0]?.isAllowed}
                  </li>
                );
              })}
            </ul>
          </div>
        </>

        {showTimeSlots && (
          <div className="timeSlots">
            <div className="timeSlotContainer">
              <p
                className="timeSlotClose"
                onClick={() => {
                  setShowTimeSlots(false);
                  setEnablePopup(true);
                  let mixObj = {
                    currentDate: dayjs().format("DD/MM/YYYY"),
                    selectedDate: dayjs(hourlyDate).format("DD/MM/YYYY"),
                    selectedTime: hourlyTime,
                  };
                  fireGtmEvent("checkInTime_selected", mixObj);
                }}
              >
                X
              </p>
              <div className="timeSlotTitle">
                <p
                  className={selectedAm === "AM" ? "selected" : ""}
                  onClick={() => setSelectedAm("AM")}
                >
                  AM
                </p>
                <p
                  className={selectedAm === "PM" ? "selected" : ""}
                  onClick={() => setSelectedAm("PM")}
                >
                  PM
                </p>
              </div>
              <div className="timeSlot">
                {timeSlots
                  .filter((time) => time.includes(selectedAm))
                  .map((slot) => {
                    const timeParts = slot.split(":");
                    const hour = parseInt(timeParts[0]);
                    const minute = parseInt(timeParts[1].split(" ")[0]);
                    const ampm = timeParts[1].split(" ")[1];
                    let curdate = dayjs(hourlyDate)
                      .set("hour", hour)
                      .set("minute", minute)
                      .set("second", 0)
                      .set("millisecond", 0)
                      .format("YYYY-MM-DD hh:mm A");

                    let notAvailable = dayjs(`${curdate} ${ampm}`).isBefore(
                      dayjs()
                    );

                    notAvailable = dayjs(`${curdate} ${ampm}`).isBefore(
                      dayjs()
                    );

                    return (
                      <span
                        key={slot}
                        className={`slot ${notAvailable ? "noSlot" : ""} ${
                          hourlyTime === slot ? "selected" : ""
                        }`}
                        onClick={() =>
                          handleSelectedTimeSlot(notAvailable, slot)
                        }
                      >
                        {slot}
                      </span>
                    );
                  })}
              </div>
              <div className="timeConfirm">
                <p>
                  {t("selected_date")}{" "}
                  <b>{dayjs(hourlyDate).format("DD-MM-YYYY")}</b>
                </p>
                <button
                  onClick={() => {
                    setShowTimeSlots(false);
                    setEnablePopup(true);
                    let mixObj = {
                      currentDate: dayjs().format("DD/MM/YYYY"),
                      selectedDate: dayjs(hourlyDate).format("DD/MM/YYYY"),
                      selectedTime: hourlyTime,
                    };
                    fireGtmEvent("checkInTime_selected", mixObj);
                  }}
                >
                  {t("select")}
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          className="landingPage__roomTitle"
          style={{ marginBottom: "-15px" }}
        >
          <span>{t(getTextKey(hotelData?.userId, "cancel_booking"))}</span>
        </div>
        <div className="landingPage__description cancelBtnContainer">
          <p>{t(getTextKey(hotelData?.userId, "existing_booking_cancel"))}</p>
          <button
            className="cancelBtn"
            onClick={() => setShowCancelPopup(true)}
          >
            {t(getTextKey(hotelData?.userId, "cancel_booking"))}
          </button>
          <button
            className="cancelBtn"
            style={{ background: "var(--blue)", color: "#fff" }}
            onClick={() => setModifyPopup(true)}
          >
            {t("Modify your Booking")}
          </button>
        </div>
      </div>
      {/*  */}
      {/* && !isRatePlans */}
      {!isOnlyCOD && !isRatePlans && (
        <CancellationPolicy
          cancellationPolicy={cancellationPolicy}
          setCancellationPolicy={setCancellationPolicy}
          dateRange={dateRange}
          // checkInTime={checkInTime}
        />

        // <div className="landingPage__cancellationPolicyContainer">
        //   <p
        //     onClick={() => {
        //       setShowCancellation(!showCancellation);
        //       showCancellation
        //         ? fireGtmEvent("cancelClosedLandingPage")
        //         : fireGtmEvent("cancelViewedLandingPage");
        //     }}
        //   >
        //     {t("cancellation_refund_policy")}
        //   </p>
        //   {showCancellation && (
        //     <ul>
        //       {/* {cancellationPolicy?.length > 0 ? (
        //         cancellationPolicy?.map((pol) => {
        //           return (
        //             <li key={pol?.id}>
        //               <span
        //                 style={{
        //                   width: "20px",
        //                   height: "20px",
        //                   border: "1px solid green",
        //                   borderRadius: "50%",
        //                   color: "green",
        //                   display: "flex",
        //                   justifyContent: "center",
        //                   alignItems: "center",
        //                   fontSize: "12px",
        //                   fontWeight: "bold",
        //                 }}
        //               >
        //                 {" "}
        //                 &#10003;
        //               </span>
        //               {t("if_cancelled")}{" "}
        //               {pol?.variables?.daysBeforeArrival === "0"
        //                 ? "on checkin day"
        //                 : pol?.variables?.daysBeforeArrival === "1"
        //                 ? "1 day before checkin"
        //                 : `${pol?.variables?.daysBeforeArrival} days before checkin`}{" "}
        //               , {pol?.variables?.chargedPercentage}% {t("deducted")}
        //             </li>
        //           );
        //         })
        //       ) : (
        //         <li>{t("free_cancellation")}</li>
        //       )} */}

        //       {/* text */}
        //       <div>
        //         {cancellationPolicy?.length > 0 &&
        //           Object.values(
        //             cancellationPolicy
        //               ?.filter((pol) => {
        //                 const currentDate = dayjs();
        //                 const policyDate = dayjs(dateRange?.startDate).subtract(
        //                   parseInt(pol?.variables?.daysBeforeArrival, 10),
        //                   "day"
        //                 );
        //                 return (
        //                   policyDate.isSame(currentDate, "day") ||
        //                   policyDate.isAfter(currentDate, "day")
        //                 );
        //               })
        //               .reduce(
        //                 (acc, pol) => {
        //                   const refundPercentage =
        //                     100 - pol?.variables?.chargedPercentage;

        //                   if (refundPercentage === 100 && !acc.fullRefund) {
        //                     acc.fullRefund = pol;
        //                   } else if (refundPercentage === 0 && !acc.noRefund) {
        //                     acc.noRefund = pol;
        //                   }

        //                   return acc;
        //                 },
        //                 { fullRefund: null, noRefund: null }
        //               )
        //           ).map((policy, id) => {
        //             if (!policy) return null;

        //             let refundText;
        //             const refundPercentage =
        //               100 - policy?.variables?.chargedPercentage;

        //             // Conditional text for the policies
        //             if (refundPercentage === 100) {
        //               refundText = "Free cancellation till ";
        //             } else if (refundPercentage === 0) {
        //               refundText = "No refund if cancelled after ";
        //             }

        //             const iconStyle = {
        //               backgroundColor: "white",
        //               borderRadius: "50%",
        //               color: "green",
        //               display: "inline-block",
        //               width: "20px",
        //               height: "20px",
        //               border: "1px solid green",
        //               textAlign: "center",
        //               lineHeight: "20px",
        //               marginRight: "8px",
        //             };

        //             return (
        //               <div
        //                 key={id}
        //                 style={{
        //                   display: "flex",
        //                   alignItems: "center",
        //                   marginBottom: "8px",
        //                 }}
        //               >
        //                 <span style={iconStyle}>✓</span>
        //                 <span>
        //                   {refundText}
        //                   {dayjs(dateRange?.startDate)
        //                     .subtract(
        //                       parseInt(
        //                         policy?.variables?.daysBeforeArrival,
        //                         10
        //                       ),
        //                       "day"
        //                     )
        //                     .format("D MMM, h:mm A")}
        //                 </span>
        //               </div>
        //             );
        //           })}
        //       </div>

        //       {/* progressbar */}

        //       <div
        //         className="progressBar"
        //         style={{ height: "30px", position: "relative" }}
        //       >
        //         <span
        //           style={{
        //             width: "8vw",
        //             height: "8vw",
        //             maxWidth: "15px",
        //             maxHeight: "15px",
        //             borderRadius: "50%",
        //             backgroundColor: "white",
        //             position: "absolute",
        //             top: "50%",
        //             left: "10px",
        //             transform: "translate(-50%, -50%)",
        //             zIndex: 10,
        //             border: "2px solid #1870eb",
        //           }}
        //         ></span>
        //         {(() => {
        //           const applicablePolicies = cancellationPolicy?.filter(
        //             (pol) => {
        //               const currentDate = dayjs();
        //               const policyDate = dayjs(dateRange?.startDate).subtract(
        //                 parseInt(pol?.variables?.daysBeforeArrival, 10),
        //                 "day"
        //               );
        //               return (
        //                 policyDate.isSame(currentDate, "day") ||
        //                 policyDate.isAfter(currentDate, "day")
        //               );
        //             }
        //           );

        //           if (applicablePolicies.length === 0) {
        //             // Show full-width "No refund" bar when no policies apply
        //             return (
        //               <div
        //                 className="progressValue"
        //                 style={{
        //                   width: "100%",
        //                   background: "#f8ecc1",
        //                   borderRadius: "10px",
        //                 }}
        //               >
        //                 <span style={{ color: "#f08732" }}>No refund</span>
        //               </div>
        //             );
        //           }

        //           return Object.values(
        //             applicablePolicies.reduce(
        //               (acc, pol) => {
        //                 const refundPercentage =
        //                   100 - pol?.variables?.chargedPercentage;

        //                 if (refundPercentage === 100 && !acc.fullRefund) {
        //                   acc.fullRefund = pol;
        //                 } else if (
        //                   refundPercentage > 0 &&
        //                   refundPercentage < 100 &&
        //                   !acc.partialRefund
        //                 ) {
        //                   acc.partialRefund = pol;
        //                 } else if (refundPercentage === 0 && !acc.noRefund) {
        //                   acc.noRefund = pol;
        //                 }

        //                 return acc;
        //               },
        //               { fullRefund: null, partialRefund: null, noRefund: null }
        //             )
        //           ).map((policy, id) => {
        //             if (!policy) return null;

        //             let refundText, backgroundColor, color;
        //             const refundPercentage =
        //               100 - policy?.variables?.chargedPercentage;

        //             if (refundPercentage === 100) {
        //               refundText = "100% refund";
        //               backgroundColor = "#1870eb";
        //               color = "white";
        //             } else if (refundPercentage > 0 && refundPercentage < 100) {
        //               refundText = "Partial refund";
        //               backgroundColor = "#eaf7ff";
        //               color = "#3f8aef";
        //             } else if (refundPercentage === 0) {
        //               refundText = "No refund";
        //               backgroundColor = "#f8ecc1";
        //               color = "#f08732";
        //             }

        //             return (
        //               <div
        //                 key={id}
        //                 className="progressValue"
        //                 style={{
        //                   width: `${policy?.width}%`,
        //                   background: backgroundColor,
        //                   borderTopLeftRadius: id === 0 ? "10px" : "",
        //                   borderBottomLeftRadius: id === 0 ? "10px" : "",
        //                   borderTopRightRadius: id === 2 ? "10px" : "",
        //                   borderBottomRightRadius: id === 2 ? "10px" : "",
        //                 }}
        //               >
        //                 <span style={{ color: color }}>{refundText}</span>
        //                 <span
        //                   className="progressValueText"
        //                   style={{ bottom: "-30px" }}
        //                 >
        //                   {dayjs(dateRange?.startDate)
        //                     .subtract(
        //                       parseInt(
        //                         policy?.variables?.daysBeforeArrival,
        //                         10
        //                       ),
        //                       "day"
        //                     )
        //                     .format("D MMM")}
        //                 </span>
        //               </div>
        //             );
        //           });
        //         })()}
        //         <div
        //           style={{
        //             width: "8vw",
        //             height: "8vw",
        //             maxWidth: "15px",
        //             maxHeight: "15px",
        //             borderRadius: "50%",
        //             backgroundColor: "white",
        //             position: "absolute",
        //             top: "50%",
        //             right: "10px",
        //             transform: "translate(50%, -50%)",
        //             zIndex: 10,
        //             border: "2px solid #f08732",
        //           }}
        //         ></div>
        //       </div>
        //       {/* table */}
        //       <table
        //         style={{
        //           border: "1px solid gray",
        //           borderCollapse: "collapse",
        //           width: "100%",
        //         }}
        //       >
        //         <thead style={{ backgroundColor: "#eaf7ff" }}>
        //           <tr>
        //             <th
        //               style={{
        //                 border: "1px solid #dddddd",
        //                 textAlign: "left",
        //                 padding: " 8px",
        //               }}
        //             >
        //               {t("date")}
        //             </th>
        //             <th
        //               style={{
        //                 border: "1px solid #dddddd",
        //                 textAlign: "left",
        //                 padding: " 8px",
        //               }}
        //             >
        //               {t("fee")}
        //             </th>
        //           </tr>
        //         </thead>
        //         <tbody>
        //           {cancellationPolicy?.length > 0 &&
        //             cancellationPolicy.map((pol) => {
        //               return (
        //                 <tr key={pol?.id}>
        //                   <td
        //                     style={{
        //                       border: "1px solid #dddddd",
        //                       textAlign: "left",
        //                       padding: "8px",
        //                     }}
        //                   >
        //                     {t("before")}{" "}
        //                     {dayjs(dateRange?.startDate)
        //                       .subtract(
        //                         parseInt(pol?.variables?.daysBeforeArrival, 10),
        //                         "day"
        //                       )
        //                       .format("D MMM ")}
        //                     {" ,"} {checkInTime}
        //                   </td>

        //                   <td
        //                     style={{
        //                       border: "1px solid #dddddd",
        //                       textAlign: "left",
        //                       padding: " 8px",
        //                     }}
        //                   >
        //                     {pol?.variables?.chargedPercentage}%{" "}
        //                     {t("of_the_booking_amount")}
        //                   </td>
        //                 </tr>
        //               );
        //             })}
        //         </tbody>
        //       </table>
        //       <span style={{ padding: "10px 0px", display: "flex" }}>
        //         {t(
        //           "cancellation_are_only_allowed_before_checkin_time_all_the_time_mentioned_above_is_in_destination_time"
        //         )}
        //       </span>
        //     </ul>
        //   )}
        // </div>
      )}
      <div className="newFooter">
        <LazyLoadComponent afterLoad={() => fireGtmEvent("footer_viewed")}>
          <PaymentOption />
        </LazyLoadComponent>
        {/* SOCIAL */}
        <>
          {Socials?.length > 0 && (
            <div className="landingPage__socialMedia" id="socialMediaLinks">
              <span>{t("follow_us_on")}</span>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {instaLink[0]?.link?.length > 2 && (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.instagram.com/${instaLink[0]?.link}`}
                    onClick={() =>
                      fireGtmEvent("social_link_clicked_insta", {
                        url: `https://www.instagram.com/${instaLink[0]?.link}`,
                      })
                    }
                  >
                    <img src={ins} alt={name + " social media"} />
                  </a>
                )}
                {fbLink[0]?.link?.length > 2 && (
                  <a
                    target="_blank"
                    href={`https://www.facebook.com/${fbLink[0]?.link}`}
                    onClick={() =>
                      fireGtmEvent("social_link_clicked_fb", {
                        url: `https://www.facebook.com/${fbLink[0]?.link}`,
                      })
                    }
                  >
                    <img src={fb} alt={name + " social media"} />
                  </a>
                )}
                {twitterLink[0]?.link?.length > 2 && (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.twitter.com/${twitterLink[0]?.link}`}
                    onClick={() =>
                      fireGtmEvent("social_link_clicked_twt", {
                        url: `https://www.twitter.com/${twitterLink[0]?.link}`,
                      })
                    }
                  >
                    <img src={tw} alt={name + " social media"} />
                  </a>
                )}
                {youtubeLink[0]?.link?.length > 2 && (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.youtube.com/${youtubeLink[0]?.link}`}
                    onClick={() =>
                      fireGtmEvent("social_link_clicked_yt", {
                        url: `https://www.youtube.com/${youtubeLink[0]?.link}`,
                      })
                    }
                  >
                    <img src={yt} alt={name + " social media"} />
                  </a>
                )}
              </div>
            </div>
          )}
        </>

        <BookDirectPopup
          showPopup={showPopup}
          setShowPop={setShowPop}
          isLowest={isLowest}
          handleMenuId={handleMenuId}
        />

        <IdleBehaviour
          setShowPop={setShowLoyalty}
          showPopup={showLoyalty}
          setextraPrice={setextraPrice}
          setShowFakeConfetti={setShowFakeConfetti}
        />

        {showFakeConfetti && selectedRooms?.length > 0 && (
          <div
            className="offerApplied"
            onClick={() => {
              setShowFakeConfetti(false);
            }}
            style={{ zIndex: 4000 }}
          >
            <div className="offerAppliedContainer">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {fakePrice && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      fontSize: "0.8rem",
                      color: "red",
                    }}
                  >
                    {currency(hotelData?.currency)}
                  </span>
                )}
                {fakePrice && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "red",
                      fontSize: "0.8rem",
                    }}
                  >
                    {(totalCost * 1.15).toFixed(
                      getFixedValue(hotelData?.currency)
                    )}
                  </span>
                )}

                <span>{currency(hotelData?.currency)}</span>
                <NumberAnimator
                  number={totalCost}
                  onDone={() => setFakePrice(true)}
                />
              </div>
              <h2>{t("additional_15_off")}</h2>
              <p>{t("offer_ends_soon")}</p>
              <button
                onClick={() => {
                  setShowFakeConfetti(false);
                }}
              >
                {t("continue")}
              </button>
            </div>
          </div>
        )}
        <>
          <Footer slug={websiteSlug} id={id} name={name} />
        </>
      </div>

      {isContinueBooking &&
        selectedRooms?.length === 0 &&
        selectedRatePlans?.length === 0 &&
        width < 900 &&
        continueBookingData?.bookingIdentity && (
          <div
            className="continueYourBooking"
            style={{
              height: "auto",
              width: "100%",
              position: "fixed",
              bottom: 0,
              left: 0,
              zIndex: "5000",
              backgroundColor: "white",
              color: "black",
              display: "flex",
              flexDirection: width > 600 ? "row" : "column",
              justifyContent: width > 600 ? "space-between" : "flex-start",
              alignItems: width > 600 ? "center" : "flex-start",
              padding: width > 600 ? "12px 16px" : "16px 20px",
              borderRadius: "12px 12px 0 0",
              boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.3)",
              maxWidth: "100%",
            }}
          >
            {width < 600 && (
              <img
                src={close}
                onClick={handleContinueBookingClose}
                style={{
                  marginLeft: width < 450 ? "86vw" : "90vw",
                  marginTop: "-10px",
                  cursor: "pointer",
                }}
              />
            )}

            {width > 600 && (
              <img
                src={close}
                onClick={handleContinueBookingClose}
                style={{
                  margin: "0vh 0vw 70px 94vw",
                  marginTop: "-10px",
                  cursor: "pointer",
                  position: "absolute",
                }}
              />
            )}

            {contentforContinueBooking()}

            <button
              onClick={handleNavigateUserToOldBooking}
              className="continue-button"
              style={{
                width: width > 600 ? "45%" : "100%",
                backgroundColor: "#17a04b",
                color: "#FFFFFF",
                padding: width > 600 ? "12px 24px" : "12px",
                borderRadius: "4px",
                border: "none",
                fontWeight: "600",
                fontSize: "16px",
                cursor: "pointer",
                marginTop: "4px",
              }}
            >
              Continue Booking
            </button>
          </div>
        )}

      {isDiscardOldBookingOpen && (
        <div className="overlay">
          <div
            className="popup"
            style={{ width: width > 350 ? "340px" : "330px" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>Do you want to discard your old booking?</p>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  marginTop: "22px",
                  marginBottom: "10px",
                }}
              >
                <button
                  onClick={handleYesDiscardoldBooking}
                  style={{
                    width: width > 600 ? "80px" : "96px",
                    height: width > 600 ? "30px" : "32px",
                    background: "red",
                    color: "white",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Yes
                </button>
                <button
                  style={{
                    width: width > 600 ? "80px" : "96px",
                    height: width > 600 ? "30px" : "32px",
                    background: "#0a8c3e",
                    color: "white",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  onClick={() => setisDiscardOldBookingOpen(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {(selectedRooms?.length > 0 || selectedRatePlans?.length > 0) && (
        <Checkout
          extraPrice={extraPrice}
          localExtraValue={localExtraValue}
          onClose={setShowLoyalty}
          showFakePrice={showFakePrice}
        />
      )}
      {/* <Cookie /> */}
      {/* Video call popup */}
      {/* NOTE: Temp commenting to resolve the google price issue */}
      {showInventoryRetargModal && (
        <InventoryRetargModal
          onClose={() => setShowInventoryRetargModal(false)}
          dateRange={dateRange}
          adults={adults}
          child={child}
        />
      )}
    </div>
  );
};
export default MainPage;
